import { CoinbaseWallet, getInjectedCoinbaseProvider, MetaMaskWallet, getInjectedMetamaskProvider, WalletConnect, TrustWallet as TrustWallet$1, assertWindowEthereum, ZerionWallet, RainbowWallet as RainbowWallet$1, getInjectedRainbowProvider, PhantomWallet, getInjectedPhantomProvider, walletIds } from '@thirdweb-dev/wallets';
import { I as Img, a as StyledDiv, u as useCustomTheme, r as radius, v as fadeInAnimation, f as ModalConfigCtx, C as Container, M as ModalHeader, T as Text, S as Spacer, B as Button, s as spacing, i as iconSize, L as Line, b as useTWLocale, p as StyledButton, E as ScreenBottomContainer, g as fontSize, d as Spinner, Y as Link, t as useScreenContext, Z as SetModalConfigCtx, V as StyledUl, P as noScrollBar, R as ModalTitle, q as TextDivider, A as IconButton, e as Label, w as Input, y as InputContainer, z as InputButton } from './formElements-1af9feb6.browser.esm.js';
import { useContext, useMemo, useState, useRef, useEffect, useCallback } from 'react';
import { keyframes } from '@emotion/react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ReloadIcon, ChevronLeftIcon } from '@radix-ui/react-icons';
import { detect } from 'detect-browser';
import QRCodeUtil from 'qrcode';
import { useCreateWalletInstance, useWalletContext, useDisconnect, useConnectionStatus } from '@thirdweb-dev/react-core';

function WalletLogoSpinner(props) {
  const loaderRadius = 20;
  const radiusFactor = 36 - loaderRadius;
  const dashArrayStart = 116 + radiusFactor;
  const dashArrayEnd = 245 + radiusFactor;
  const dashOffset = -1 * (360 + radiusFactor * 1.75);
  return /*#__PURE__*/jsx(LogoContainer, {
    "data-error": props.error,
    children: /*#__PURE__*/jsx("div", {
      "data-container": true,
      style: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      children: /*#__PURE__*/jsxs("div", {
        "data-img-container": true,
        children: [/*#__PURE__*/jsx("svg", {
          viewBox: "0 0 110 110",
          style: {
            display: props.error ? "none" : "block"
          },
          children: /*#__PURE__*/jsx("rect", {
            x: "2",
            y: "2",
            width: "106",
            height: "106",
            rx: loaderRadius,
            strokeDasharray: `${dashArrayStart} ${dashArrayEnd}`,
            strokeDashoffset: dashOffset,
            strokeLinecap: "round",
            fill: "none",
            strokeWidth: 4
          })
        }), /*#__PURE__*/jsx(Img, {
          src: props.iconUrl,
          width: "80",
          height: "80"
        })]
      })
    })
  });
}
const dashRotateAnimation = keyframes`
from {
  stroke-dashoffset: 0px;
}
`;
const shakeErrorAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
`;
const plusAnimation = keyframes`
0% {
  transform: scale(0.95);
}
100% {
  opacity: 0;
  transform: scale(1.4);
}
`;
const LogoContainer = /* @__PURE__ */StyledDiv(() => {
  const theme = useCustomTheme();
  return {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    borderRadius: radius.xl,
    "[data-img-container]": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative"
    },
    "&[data-error='true'] [data-container]": {
      animation: `${shakeErrorAnimation} 0.25s linear`
    },
    "&[data-error='true'] [data-img-container]::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: theme.colors.danger,
      animation: `${plusAnimation} 1.5s ease infinite`,
      borderRadius: "20px",
      zIndex: -1
    },
    svg: {
      position: "absolute",
      /* can't use inset because safari doesn't like it */
      left: "-8px",
      top: "-8px",
      width: "calc(100% + 16px)",
      height: "calc(100% + 16px)",
      animation: `${fadeInAnimation} 400ms ease`
    },
    img: {
      zIndex: 100
    },
    rect: {
      animation: `${dashRotateAnimation} 1.2s linear infinite`,
      stroke: theme.colors.accentText
    }
  };
});

const ConnectingScreen = props => {
  const {
    locale
  } = props;
  const modalConfig = useContext(ModalConfigCtx);
  return /*#__PURE__*/jsxs(Container, {
    animate: "fadein",
    fullHeight: true,
    flex: "column",
    children: [/*#__PURE__*/jsx(Container, {
      p: "lg",
      style: {
        paddingBottom: 0
      },
      children: /*#__PURE__*/jsx(ModalHeader, {
        title: props.walletName,
        onBack: props.hideBackButton ? undefined : props.onBack
      })
    }), /*#__PURE__*/jsxs(Container, {
      flex: "column",
      center: "y",
      expand: true,
      px: modalConfig.modalSize === "compact" ? "lg" : "xxl",
      relative: true,
      style: {
        paddingTop: 0
      },
      children: [/*#__PURE__*/jsx(Container, {
        py: "3xl",
        children: /*#__PURE__*/jsx(WalletLogoSpinner, {
          error: props.errorConnecting,
          iconUrl: props.walletIconURL
        })
      }), /*#__PURE__*/jsxs(Container, {
        animate: "fadein",
        style: {
          animationDuration: "200ms"
        },
        children: [/*#__PURE__*/jsx(Text, {
          center: true,
          color: "primaryText",
          size: "lg",
          weight: 600,
          children: props.errorConnecting ? locale.failed : locale.inProgress
        }), /*#__PURE__*/jsx(Spacer, {
          y: "md"
        }), !props.errorConnecting ? /*#__PURE__*/jsx(Text, {
          balance: true,
          center: true,
          multiline: true,
          children: locale.instruction
        }) : /*#__PURE__*/jsx(Container, {
          flex: "row",
          center: "x",
          animate: "fadein",
          children: /*#__PURE__*/jsxs(Button, {
            fullWidth: true,
            variant: "accent",
            onClick: props.onRetry,
            style: {
              gap: spacing.xs,
              alignItems: "center"
            },
            children: [/*#__PURE__*/jsx(ReloadIcon, {
              width: iconSize.sm,
              height: iconSize.sm
            }), " ", locale.tryAgain]
          })
        })]
      })]
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsx(Line, {}), /*#__PURE__*/jsx(Container, {
      flex: "row",
      center: "x",
      p: "lg",
      children: /*#__PURE__*/jsx(Button, {
        variant: "link",
        onClick: props.onGetStarted,
        children: locale.getStartedLink
      })
    })]
  });
};

function detectEnv(userAgent) {
  return detect(userAgent);
}

/**
 * @internal
 */
function isAndroid() {
  const os = detectOS();
  return os ? os.toLowerCase().includes("android") : false;
}

/**
 * @internal
 */
function isIOS() {
  const os = detectOS();
  return os ? os.toLowerCase().includes("ios") || os.toLowerCase().includes("mac") && navigator.maxTouchPoints > 1 : false;
}

/**
 * @internal
 */
function detectOS() {
  const env = detectEnv();
  return env?.os ? env.os : undefined;
}

/**
 * @internal
 */
function isMobile() {
  const os = detectOS();
  return os ? isAndroid() || isIOS() : false;
}

const QRCode = props => {
  const size = props.size || 310;
  return /*#__PURE__*/jsxs("div", {
    style: {
      position: "relative",
      display: "flex",
      justifyContent: "center"
    },
    children: [props.qrCodeUri ? /*#__PURE__*/jsx(QRCodeContainer, {
      children: /*#__PURE__*/jsx(QRCodeRenderer, {
        uri: props.qrCodeUri,
        size: size + 20,
        ecl: "M",
        clearSize: props.QRIcon ? 70 : undefined
      })
    }) : /*#__PURE__*/jsxs(QRPlaceholder, {
      style: {
        width: `${size}px`,
        height: `${size}px`
      },
      children: [/*#__PURE__*/jsx("span", {
        "data-v1": true
      }), /*#__PURE__*/jsx("span", {
        "data-v2": true
      }), /*#__PURE__*/jsx("span", {
        "data-v3": true
      }), /*#__PURE__*/jsx("div", {})]
    }), props.QRIcon && /*#__PURE__*/jsx(IconContainer, {
      children: props.QRIcon
    })]
  });
};
const IconContainer = /* @__PURE__ */StyledDiv({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  zIndex: 1000
});
const QRCodeContainer = /* @__PURE__ */StyledDiv(() => {
  const theme = useCustomTheme();
  return {
    animation: `${fadeInAnimation} 600ms ease`,
    "--ck-qr-dot-color": theme.colors.primaryText,
    "--ck-body-background": theme.colors.modalBg,
    "--ck-qr-background": theme.colors.modalBg
  };
});
const generateMatrix = (value, errorCorrectionLevel) => {
  const arr = Array.prototype.slice.call(QRCodeUtil.create(value, {
    errorCorrectionLevel
  }).modules.data, 0);
  const sqrt = Math.sqrt(arr.length);
  return arr.reduce((rows, key, index) => (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows, []);
};
const PlaceholderKeyframes = keyframes`
  0%{ background-position: 100% 0; }
  100%{ background-position: -100% 0; }
`;
const QRPlaceholder = /* @__PURE__ */StyledDiv(() => {
  const theme = useCustomTheme();
  return {
    "--color": theme.colors.skeletonBg,
    "--bg": theme.colors.modalBg,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: radius.md,
    "> div": {
      zIndex: 4,
      position: "relative",
      width: "28%",
      height: "28%",
      borderRadius: "5px",
      background: "var(--bg)",
      boxShadow: "0 0 0 7px var(--bg)"
    },
    "> span": {
      zIndex: 4,
      position: "absolute",
      background: "var(--color)",
      borderRadius: "12px",
      width: "13.25%",
      height: "13.25%",
      boxShadow: "0 0 0 4px var(--bg)",
      "&:before": {
        content: '""',
        position: "absolute",
        inset: "9px",
        borderRadius: "3px",
        boxShadow: "0 0 0 4px var(--bg)"
      },
      "&[data-v1]": {
        top: 0,
        left: 0
      },
      "&[data-v2]": {
        top: 0,
        right: 0
      },
      "&[data-v3]": {
        bottom: 0,
        left: 0
      }
    },
    "&:before": {
      zIndex: 3,
      content: '""',
      position: "absolute",
      inset: 0,
      background: "repeat",
      backgroundSize: "1.888% 1.888%",
      backgroundImage: "radial-gradient(var(--color) 41%, transparent 41%)"
    },
    "&::after": {
      zIndex: 100,
      content: '""',
      position: "absolute",
      inset: 0,
      transform: "scale(1.5) rotate(45deg)",
      background: "linear-gradient(90deg, transparent 50%, var(--color), transparent)",
      backgroundSize: "200% 100%",
      animation: `${PlaceholderKeyframes} 1000ms linear infinite both`
    }
  };
});
function QRCodeRenderer(_ref) {
  let {
    ecl = "M",
    size: sizeProp = 200,
    uri,
    clearSize = 0,
    image,
    imageBackground = "transparent"
  } = _ref;
  const logoSize = clearSize;
  const size = sizeProp - 10 * 2;
  const dots = useMemo(() => {
    const dotsArray = [];
    const matrix = generateMatrix(uri, ecl);
    const cellSize = size / matrix.length;
    const qrList = [{
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: 0,
      y: 1
    }];
    qrList.forEach(_ref2 => {
      let {
        x,
        y
      } = _ref2;
      const x1 = (matrix.length - 7) * cellSize * x;
      const y1 = (matrix.length - 7) * cellSize * y;
      for (let i = 0; i < 3; i++) {
        dotsArray.push( /*#__PURE__*/jsx("rect", {
          fill: i % 2 !== 0 ? "var(--ck-qr-background, var(--ck-body-background))" : "var(--ck-qr-dot-color)",
          rx: (i - 2) * -5 + (i === 0 ? 2 : 3),
          ry: (i - 2) * -5 + (i === 0 ? 2 : 3),
          width: cellSize * (7 - i * 2),
          height: cellSize * (7 - i * 2),
          x: x1 + cellSize * i,
          y: y1 + cellSize * i
        }, `${i}-${x}-${y}`));
      }
    });
    if (image) {
      const x1 = (matrix.length - 7) * cellSize * 1;
      const y1 = (matrix.length - 7) * cellSize * 1;
      dotsArray.push( /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("rect", {
          fill: imageBackground,
          rx: (0 - 2) * -5 + 2,
          ry: (0 - 2) * -5 + 2,
          width: cellSize * (7 - 0 * 2),
          height: cellSize * (7 - 0 * 2),
          x: x1 + cellSize * 0,
          y: y1 + cellSize * 0
        }), /*#__PURE__*/jsx("foreignObject", {
          width: cellSize * (7 - 0 * 2),
          height: cellSize * (7 - 0 * 2),
          x: x1 + cellSize * 0,
          y: y1 + cellSize * 0,
          children: /*#__PURE__*/jsx("div", {
            style: {
              borderRadius: (0 - 2) * -5 + 2,
              overflow: "hidden"
            },
            children: image
          })
        })]
      }));
    }
    const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
    const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
    const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
    matrix.forEach((row, i) => {
      row.forEach((_, j) => {
        if (matrix[i][j]) {
          // Do not render dots under position squares
          if (!(i < 7 && j < 7 || i > matrix.length - 8 && j < 7 || i < 7 && j > matrix.length - 8)) {
            //if (image && i > matrix.length - 9 && j > matrix.length - 9) return;
            if (image || !(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
              dotsArray.push( /*#__PURE__*/jsx("circle", {
                cx: i * cellSize + cellSize / 2,
                cy: j * cellSize + cellSize / 2,
                fill: "var(--ck-qr-dot-color)",
                r: cellSize / 3
              }, `circle-${i}-${j}`));
            }
          }
        }
      });
    });
    return dotsArray;
  }, [ecl, image, imageBackground, logoSize, size, uri]);
  return /*#__PURE__*/jsxs("svg", {
    height: size,
    width: size,
    viewBox: `0 0 ${size} ${size}`,
    style: {
      width: size,
      height: size
    },
    children: [/*#__PURE__*/jsx("rect", {
      fill: "transparent",
      height: size,
      width: size
    }), dots]
  });
}

function openWindow(uri) {
  if (uri.startsWith("http")) {
    // taken from for https://github.com/rainbow-me/rainbowkit/

    // Using 'window.open' causes issues on iOS in non-Safari browsers and
    // WebViews where a blank tab is left behind after connecting.
    // This is especially bad in some WebView scenarios (e.g. following a
    // link from Twitter) where the user doesn't have any mechanism for
    // closing the blank tab.
    // For whatever reason, links with a target of "_blank" don't suffer
    // from this problem, and programmatically clicking a detached link
    // element with the same attributes also avoids the issue.

    const link = document.createElement("a");
    link.href = uri;
    link.target = "_blank";
    link.rel = "noreferrer noopener";
    link.click();
  } else {
    window.location.href = uri;
  }
}

const AppleIcon = props => {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 23 28",
    fill: "none",
    children: /*#__PURE__*/jsx("path", {
      d: "M22.4181 21.6041C22.008 22.5506 21.5224 23.422 20.9599 24.223C20.1931 25.3151 19.5652 26.0711 19.0814 26.4908C18.3313 27.1799 17.5277 27.5327 16.6671 27.5528C16.0493 27.5528 15.3043 27.3772 14.437 27.021C13.5669 26.6664 12.7673 26.4908 12.0362 26.4908C11.2694 26.4908 10.447 26.6664 9.56734 27.021C8.68636 27.3772 7.97665 27.5628 7.43403 27.5812C6.60879 27.6164 5.78624 27.2534 4.96519 26.4908C4.44116 26.0343 3.78569 25.2516 3.00047 24.1428C2.15799 22.9587 1.46536 21.5857 0.92274 20.0203C0.341611 18.3295 0.050293 16.6922 0.050293 15.1071C0.050293 13.2914 0.44307 11.7253 1.2298 10.413C1.84809 9.35886 2.67065 8.52734 3.70014 7.91691C4.72963 7.30648 5.84199 6.99541 7.03991 6.97551C7.69538 6.97551 8.55493 7.17804 9.6231 7.57607C10.6882 7.97544 11.3722 8.17797 11.672 8.17797C11.8962 8.17797 12.656 7.94116 13.944 7.46904C15.162 7.0312 16.19 6.84991 17.0321 6.92133C19.3141 7.10529 21.0285 8.00387 22.1687 9.62276C20.1278 10.858 19.1182 12.5881 19.1383 14.8076C19.1567 16.5363 19.7846 17.9749 21.0185 19.1172C21.5777 19.6473 22.2022 20.0571 22.897 20.3481C22.7463 20.7846 22.5872 21.2027 22.4181 21.6041ZM17.1845 1.03178C17.1845 2.38678 16.6889 3.65194 15.7011 4.82296C14.509 6.21507 13.0672 7.0195 11.5036 6.89256C11.4837 6.73 11.4721 6.55892 11.4721 6.37913C11.4721 5.07833 12.039 3.68622 13.0457 2.54798C13.5484 1.97167 14.1876 1.49247 14.9628 1.11021C15.7363 0.733653 16.4679 0.525407 17.156 0.489746C17.1761 0.670889 17.1845 0.85206 17.1845 1.03178Z",
      fill: "#959CA0"
    })
  });
};

const ChromeIcon = props => {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 190.5 190.5",
    children: /*#__PURE__*/jsxs("g", {
      transform: "translate(90.669 -507.469)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M4.583 650.342c26.304 0 47.627-21.324 47.627-47.628s-21.323-47.628-47.627-47.628-47.627 21.324-47.627 47.628 21.323 47.628 47.627 47.628z",
        fill: "#fff",
        clipPath: "none",
        mask: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M-36.664 626.539l-41.24-71.43c-8.362 14.479-12.765 30.904-12.765 47.625s4.401 33.146 12.762 47.625 20.387 26.503 34.868 34.86 30.908 12.755 47.628 12.75l41.24-71.43v-.011c-4.177 7.244-10.188 13.26-17.428 17.443a47.62 47.62 0 0 1-47.632.007 47.62 47.62 0 0 1-17.433-17.437z",
        fill: "#229342",
        clipPath: "none",
        mask: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M45.826 626.536l-41.239 71.43c16.72.003 33.146-4.398 47.626-12.757s26.504-20.384 34.863-34.865a95.24 95.24 0 0 0 12.755-47.627c-.003-16.72-4.408-33.145-12.772-47.623H4.58l-.01.007a47.62 47.62 0 0 1 23.819 6.372c7.243 4.179 13.257 10.19 17.439 17.431a47.62 47.62 0 0 1-.001 47.633z",
        fill: "#fbc116",
        clipPath: "none",
        mask: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M4.583 640.43c20.824 0 37.705-16.881 37.705-37.706s-16.881-37.705-37.705-37.705-37.705 16.881-37.705 37.705 16.881 37.706 37.705 37.706z",
        fill: "#1a73e8",
        clipPath: "none",
        mask: "none"
      }), /*#__PURE__*/jsx("path", {
        d: "M4.583 555.097h82.479c-8.358-14.481-20.381-26.507-34.861-34.868a95.23 95.23 0 0 0-47.625-12.76c-16.72.001-33.145 4.404-47.623 12.767a95.23 95.23 0 0 0-34.856 34.872l41.24 71.43.011.006a47.62 47.62 0 0 1-.015-47.633c4.179-7.242 10.193-13.256 17.434-17.436s15.456-6.381 23.818-6.379z",
        fill: "#e33b2e",
        clipPath: "none",
        mask: "none"
      })]
    })
  });
};

const PlayStoreIcon = props => {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 23 26",
    fill: "none",
    children: [/*#__PURE__*/jsx("path", {
      d: "M10.5832 12.0978L0.0976562 23.2275C0.0980507 23.2298 0.0988382 23.2317 0.0992076 23.2341C0.420793 24.4427 1.52467 25.3326 2.83473 25.3326C3.35844 25.3326 3.85012 25.191 4.27179 24.9424L4.30528 24.9228L16.1087 18.1117L10.5838 12.0977",
      fill: "#EB3131"
    }), /*#__PURE__*/jsx("path", {
      d: "M21.1922 10.2046L21.1821 10.1977L16.0862 7.2435L10.345 12.3523L16.1061 18.1127L21.1752 15.1879C22.0639 14.7081 22.6672 13.7712 22.6672 12.6908C22.6672 11.6182 22.072 10.6859 21.1922 10.2046Z",
      fill: "#F6B60B"
    }), /*#__PURE__*/jsx("path", {
      d: "M0.0961678 2.10416C0.0331317 2.33661 0 2.58009 0 2.83292V22.5002C0 22.7526 0.0327407 22.9969 0.0965672 23.2285L10.9441 12.3832L0.0965672 2.10444",
      fill: "#5778C5"
    }), /*#__PURE__*/jsx("path", {
      d: "M10.6603 12.6667L16.088 7.24061L4.29785 0.404818C3.8693 0.148138 3.36912 0 2.83391 0C1.52384 0 0.418474 0.891502 0.0968301 2.10147C0.0964356 2.10265 0.0964355 2.10347 0.0964355 2.1045L10.6603 12.6669",
      fill: "#3BAD49"
    })]
  });
};

const GetStartedScreen = _ref => {
  let {
    walletName,
    walletIconURL,
    appleStoreLink,
    googlePlayStoreLink,
    chromeExtensionLink,
    header,
    footer,
    onBack,
    locale: localeProp
  } = _ref;
  const [showScreen, setShowScreen] = useState("base");
  const locale = useTWLocale().connectWallet.download;
  const isScanScreen = showScreen === "android-scan" || showScreen === "ios-scan";
  const handleBack = onBack ? () => {
    if (showScreen === "base") {
      onBack();
    } else {
      setShowScreen("base");
    }
  } : undefined;
  return /*#__PURE__*/jsx(Container, {
    fullHeight: true,
    flex: "column",
    animate: "fadein",
    children: /*#__PURE__*/jsxs(Container, {
      expand: true,
      flex: "column",
      p: "lg",
      children: [showScreen === "android-scan" && googlePlayStoreLink && /*#__PURE__*/jsx(InstallScanScreen, {
        platformIcon: /*#__PURE__*/jsx(PlayStoreIcon, {
          size: iconSize.md
        }),
        url: googlePlayStoreLink,
        platform: "Google Play",
        walletName: walletName,
        walletIconURL: walletIconURL,
        onBack: handleBack,
        locale: {
          scanToDownload: localeProp.scanToDownload
        }
      }), showScreen === "ios-scan" && appleStoreLink && /*#__PURE__*/jsx(InstallScanScreen, {
        platformIcon: /*#__PURE__*/jsx(AppleIcon, {
          size: iconSize.md
        }),
        url: appleStoreLink,
        platform: "App Store",
        walletName: walletName,
        walletIconURL: walletIconURL,
        onBack: handleBack,
        locale: {
          scanToDownload: localeProp.scanToDownload
        }
      }), showScreen === "base" && /*#__PURE__*/jsxs(Container, {
        expand: true,
        flex: "column",
        children: [header || /*#__PURE__*/jsx(ModalHeader, {
          onBack: handleBack,
          title: walletName
        }), /*#__PURE__*/jsx(Spacer, {
          y: "xl"
        }), /*#__PURE__*/jsx(Container, {
          expand: true,
          animate: "fadein",
          flex: "column",
          center: "y",
          style: {
            minHeight: "250px"
          },
          children: /*#__PURE__*/jsxs(Container, {
            flex: "column",
            gap: "xs",
            children: [chromeExtensionLink && /*#__PURE__*/jsxs(ButtonLink, {
              onClick: () => {
                openWindow(chromeExtensionLink);
              },
              children: [/*#__PURE__*/jsx(ChromeIcon, {
                size: iconSize.lg
              }), /*#__PURE__*/jsx("span", {
                children: locale.chrome
              })]
            }), googlePlayStoreLink && /*#__PURE__*/jsxs(ButtonLink, {
              as: "button",
              onClick: () => {
                if (isMobile()) {
                  openWindow(googlePlayStoreLink);
                } else {
                  setShowScreen("android-scan");
                }
              },
              children: [/*#__PURE__*/jsx(PlayStoreIcon, {
                size: iconSize.lg
              }), /*#__PURE__*/jsx("span", {
                children: locale.android
              })]
            }), appleStoreLink && /*#__PURE__*/jsxs(ButtonLink, {
              as: "button",
              onClick: () => {
                if (isMobile()) {
                  openWindow(appleStoreLink);
                } else {
                  setShowScreen("ios-scan");
                }
              },
              children: [/*#__PURE__*/jsx(AppleIcon, {
                size: iconSize.lg
              }), /*#__PURE__*/jsx("span", {
                children: locale.iOS
              })]
            })]
          })
        })]
      }), !isScanScreen && footer]
    })
  });
};
const InstallScanScreen = props => {
  return /*#__PURE__*/jsxs(Container, {
    animate: "fadein",
    expand: true,
    children: [/*#__PURE__*/jsx(ModalHeader, {
      title: props.walletName,
      onBack: props.onBack
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsxs(Container, {
      flex: "column",
      expand: true,
      center: "both",
      style: {
        textAlign: "center"
      },
      children: [/*#__PURE__*/jsx(QRCode, {
        qrCodeUri: props.url,
        QRIcon: /*#__PURE__*/jsx(Img, {
          src: props.walletIconURL,
          width: iconSize.xxl,
          height: iconSize.xxl
        })
      }), /*#__PURE__*/jsx(Spacer, {
        y: "xl"
      }), /*#__PURE__*/jsx(Text, {
        multiline: true,
        center: true,
        balance: true,
        children: props.locale.scanToDownload
      }), /*#__PURE__*/jsx(Spacer, {
        y: "xs"
      })]
    })]
  });
};
const ButtonLink = /* @__PURE__ */StyledButton(() => {
  const theme = useCustomTheme();
  return {
    all: "unset",
    textDecoration: "none",
    padding: `${spacing.sm} ${spacing.md}`,
    borderRadius: radius.sm,
    display: "flex",
    alignItems: "center",
    gap: spacing.md,
    cursor: "pointer",
    boxSizing: "border-box",
    width: "100%",
    fontWeight: 500,
    color: theme.colors.secondaryButtonText,
    background: theme.colors.secondaryButtonBg,
    transition: "100ms ease",
    "&:hover": {
      background: theme.colors.secondaryButtonHoverBg,
      textDecoration: "none",
      color: theme.colors.primaryText
    }
  };
});

const ScanScreen = props => {
  const modalConfig = useContext(ModalConfigCtx);
  return /*#__PURE__*/jsxs(Container, {
    fullHeight: true,
    flex: "column",
    animate: "fadein",
    children: [/*#__PURE__*/jsx(Container, {
      p: "lg",
      children: /*#__PURE__*/jsx(ModalHeader, {
        onBack: props.hideBackButton ? undefined : props.onBack,
        title: props.walletName
      })
    }), /*#__PURE__*/jsx(Spacer, {
      y: "sm"
    }), /*#__PURE__*/jsx(Container, {
      expand: true,
      flex: "column",
      px: "lg",
      center: "both",
      children: /*#__PURE__*/jsxs("div", {
        style: {
          textAlign: "center"
        },
        children: [/*#__PURE__*/jsx(QRCode, {
          qrCodeUri: props.qrCodeUri,
          QRIcon: /*#__PURE__*/jsx(Img, {
            width: iconSize.xxl,
            height: iconSize.xxl,
            src: props.walletIconURL
          })
        }), /*#__PURE__*/jsx(Spacer, {
          y: "lg"
        }), /*#__PURE__*/jsx(Text, {
          center: true,
          multiline: true,
          balance: true,
          style: {
            paddingInline: spacing.lg
          },
          children: props.qrScanInstruction
        })]
      })
    }), /*#__PURE__*/jsx(Spacer, {
      y: "lg"
    }), /*#__PURE__*/jsx(ScreenBottomContainer, {
      style: {
        border: modalConfig.modalSize === "compact" ? undefined : "none"
      },
      children: /*#__PURE__*/jsx(Button, {
        variant: "link",
        onClick: props.onGetStarted,
        style: {
          fontSize: fontSize.sm,
          textAlign: "center"
        },
        children: props.getStartedLink
      })
    })]
  });
};

const CoinbaseScan = _ref => {
  let {
    walletConfig,
    onConnected,
    onGetStarted,
    onBack,
    hideBackButton,
    setConnectionStatus,
    setConnectedWallet
  } = _ref;
  const locale = useTWLocale().wallets.coinbaseWallet;
  const createInstance = useCreateWalletInstance();
  const [qrCodeUri, setQrCodeUri] = useState(undefined);
  const {
    chainToConnect
  } = useWalletContext();
  const scanStarted = useRef(false);
  useEffect(() => {
    if (scanStarted.current) {
      return;
    }
    scanStarted.current = true;
    (async () => {
      const wallet = createInstance(walletConfig);
      const uri = await wallet.getQrUrl();
      setQrCodeUri(uri || undefined);
      setConnectionStatus("connecting");
      try {
        await wallet.connect({
          chainId: chainToConnect?.chainId
        });
        setConnectedWallet(wallet);
        onConnected();
      } catch {
        setConnectionStatus("disconnected");
      }
    })();
  }, [createInstance, onConnected, walletConfig, chainToConnect?.chainId, setConnectedWallet, setConnectionStatus]);
  return /*#__PURE__*/jsx(ScanScreen, {
    qrScanInstruction: locale.scanScreen.instruction,
    onBack: onBack,
    onGetStarted: onGetStarted,
    qrCodeUri: qrCodeUri,
    walletName: walletConfig.meta.name,
    walletIconURL: walletConfig.meta.iconURL,
    hideBackButton: hideBackButton,
    getStartedLink: locale.getStartedLink
  });
};

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

const CoinbaseConnectUI = _ref => {
  let {
    walletConfig,
    connected,
    goBack,
    supportedWallets,
    setConnectedWallet,
    setConnectionStatus,
    connect
  } = _ref;
  const {
    meta
  } = walletConfig;
  const [screen, setScreen] = useState("loading");
  const locale = useTWLocale().wallets.coinbaseWallet;
  const [errorConnecting, setErrorConnecting] = useState(false);
  const hideBackButton = supportedWallets.length === 1;
  const connectToExtension = useCallback(async () => {
    try {
      setErrorConnecting(false);
      connectPrompted.current = true;
      await wait(1000);
      setScreen("connecting");
      await connect();
      connected();
    } catch (e) {
      setErrorConnecting(true);
      console.error(e);
    }
  }, [connected, connect]);
  const connectPrompted = useRef(false);
  useEffect(() => {
    if (screen !== "loading") {
      return;
    }
    if (connectPrompted.current) {
      return;
    }
    const isInstalled = walletConfig.isInstalled ? walletConfig.isInstalled() : false;

    // if loading
    (async () => {
      if (isInstalled) {
        connectToExtension();
      }

      // if metamask is not injected
      else {
        if (isMobile()) {
          // coinbase will redirect to download page for coinbase wallet apps
          connect();
        } else {
          setScreen("scanning");
        }
      }
    })();
  }, [screen, walletConfig, connect, connectToExtension]);
  if (screen === "connecting" || screen === "loading") {
    return /*#__PURE__*/jsx(ConnectingScreen, {
      locale: {
        getStartedLink: locale.getStartedLink,
        instruction: locale.connectionScreen.instruction,
        tryAgain: locale.connectionScreen.retry,
        inProgress: locale.connectionScreen.inProgress,
        failed: locale.connectionScreen.failed
      },
      errorConnecting: errorConnecting,
      onGetStarted: () => setScreen("get-started"),
      onRetry: connectToExtension,
      hideBackButton: hideBackButton,
      onBack: goBack,
      walletName: meta.name,
      walletIconURL: meta.iconURL
    });
  }
  if (screen === "get-started") {
    return /*#__PURE__*/jsx(GetStartedScreen, {
      locale: {
        scanToDownload: locale.getStartedScreen.instruction
      },
      walletIconURL: meta.iconURL,
      walletName: meta.name,
      chromeExtensionLink: meta.urls?.chrome,
      googlePlayStoreLink: meta.urls?.android,
      appleStoreLink: meta.urls?.ios,
      onBack: () => {
        goBack();
      }
    });
  }
  if (screen === "scanning") {
    return /*#__PURE__*/jsx(CoinbaseScan, {
      onBack: goBack,
      onConnected: connected,
      onGetStarted: () => setScreen("get-started"),
      walletConfig: walletConfig,
      hideBackButton: hideBackButton,
      setConnectedWallet: setConnectedWallet,
      setConnectionStatus: setConnectionStatus
    });
  }
  return null;
};

/**
 * @wallet
 */

/**
 * A wallet configurator for [Coinbase Wallet](https://www.coinbase.com/wallet) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * coinbaseWallet({
 *  qrmodal: "custom",
 *  recommended: true,
 * })
 * ```
 *
 * @param options -
 * Optional object containing the following properties to configure the wallet
 *
 * ### qrmodal (optional)
 * Whether to use the Coinbase's default QR Code modal or show the custom UI in ConnectWallet Modal.
 *
 * The default is `"custom"`
 *
 * ### recommended (optional)
 * If true, the wallet will be tagged as "recommended" in [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) Modal UI
 *
 * @wallet
 */
const coinbaseWallet = options => {
  const qrmodal = options?.qrmodal || "custom";
  return {
    id: CoinbaseWallet.id,
    recommended: options?.recommended,
    meta: {
      name: "Coinbase Wallet",
      iconURL: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iOCIgZmlsbD0iIzA1NTVGRiIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMzMwM184NjM0KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuMzMxMiA0SDM1LjY2NzJDNDAuMjcwNCA0IDQ0IDguMDEyOCA0NCAxMi45NjMyVjM1LjAzNjhDNDQgMzkuOTg3MiA0MC4yNzA0IDQ0IDM1LjY2ODggNDRIMTIuMzMxMkM3LjcyOTYgNDQgNCAzOS45ODcyIDQgMzUuMDM2OFYxMi45NjMyQzQgOC4wMTI4IDcuNzI5NiA0IDEyLjMzMTIgNFoiIGZpbGw9IiMwMDUyRkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNC4wMDAzIDkuNzkzNDZDMzEuODQ2NyA5Ljc5MzQ2IDM4LjIwNjcgMTYuMTUzNSAzOC4yMDY3IDIzLjk5OTlDMzguMjA2NyAzMS44NDYzIDMxLjg0NjcgMzguMjA2MyAyNC4wMDAzIDM4LjIwNjNDMTYuMTUzOSAzOC4yMDYzIDkuNzkzOTUgMzEuODQ2MyA5Ljc5Mzk1IDIzLjk5OTlDOS43OTM5NSAxNi4xNTM1IDE2LjE1MzkgOS43OTM0NiAyNC4wMDAzIDkuNzkzNDZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwLjUwMDYgMTkuNDU5SDI3LjQ5NzRDMjguMDczNCAxOS40NTkgMjguNTM5IDE5Ljk2MTQgMjguNTM5IDIwLjU3OVYyNy40MTlDMjguNTM5IDI4LjAzODIgMjguMDcxOCAyOC41MzkgMjcuNDk3NCAyOC41MzlIMjAuNTAwNkMxOS45MjQ2IDI4LjUzOSAxOS40NTkgMjguMDM2NiAxOS40NTkgMjcuNDE5VjIwLjU3OUMxOS40NTkgMTkuOTYxNCAxOS45MjYyIDE5LjQ1OSAyMC41MDA2IDE5LjQ1OVoiIGZpbGw9IiMwMDUyRkYiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zMzAzXzg2MzQiPgo8cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==",
      urls: {
        chrome: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
        android: "https://play.google.com/store/apps/details?id=org.toshi",
        ios: "https://apps.apple.com/us/app/coinbase-wallet-nfts-crypto/id1278383455"
      }
    },
    create(walletOptions) {
      return new CoinbaseWallet({
        ...walletOptions,
        headlessMode: qrmodal === "custom"
      });
    },
    connectUI: qrmodal === "custom" ? CoinbaseConnectUI : CoinbaseNativeModalConnectUI,
    isInstalled() {
      return !!getInjectedCoinbaseProvider();
    }
  };
};
const CoinbaseNativeModalConnectUI = _ref => {
  let {
    connected,
    walletConfig,
    show,
    hide,
    supportedWallets,
    theme,
    goBack,
    setConnectionStatus,
    setConnectedWallet
  } = _ref;
  const createWalletInstance = useCreateWalletInstance();
  const prompted = useRef(false);
  const singleWallet = supportedWallets.length === 1;
  useEffect(() => {
    if (prompted.current) {
      return;
    }
    prompted.current = true;
    (async () => {
      hide();
      const wallet = createWalletInstance(walletConfig);
      wallet.theme = theme;
      setConnectionStatus("connecting");
      try {
        await wallet.connect();
        setConnectedWallet(wallet);
        connected();
      } catch (e) {
        setConnectionStatus("disconnected");
        if (!singleWallet) {
          goBack();
          show();
        }
        console.error(e);
      }
    })();
  }, [walletConfig, singleWallet, createWalletInstance, theme, setConnectionStatus, setConnectedWallet, hide, connected, goBack, show]);
  return null;
};

var coinbaseWallet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  coinbaseWallet: coinbaseWallet,
  CoinbaseNativeModalConnectUI: CoinbaseNativeModalConnectUI
});

const MetamaskScan = props => {
  const {
    onBack,
    onConnected,
    onGetStarted,
    walletConfig,
    hideBackButton,
    setConnectedWallet,
    setConnectionStatus,
    createWalletInstance
  } = props;
  const locale = useTWLocale().wallets.metamaskWallet;
  const [qrCodeUri, setQrCodeUri] = useState();
  const {
    chainToConnect
  } = useWalletContext();
  const scanStarted = useRef(false);
  useEffect(() => {
    if (scanStarted.current) {
      return;
    }
    scanStarted.current = true;
    const metamask = createWalletInstance();
    metamask.connectWithQrCode({
      chainId: chainToConnect?.chainId,
      onQrCodeUri(uri) {
        setQrCodeUri(uri);
      },
      onConnected() {
        setConnectionStatus("connecting");
        setConnectedWallet(metamask);
        onConnected();
      }
    });
  }, [setConnectedWallet, chainToConnect, onConnected, walletConfig, setConnectionStatus, createWalletInstance]);
  return /*#__PURE__*/jsx(ScanScreen, {
    qrScanInstruction: locale.scanScreen.instruction,
    onBack: onBack,
    onGetStarted: onGetStarted,
    qrCodeUri: qrCodeUri,
    walletName: walletConfig.meta.name,
    walletIconURL: walletConfig.meta.iconURL,
    hideBackButton: hideBackButton,
    getStartedLink: locale.getStartedLink
  });
};

const metamaskUris = {
  ios: "metamask://",
  android: "https://metamask.app.link/",
  other: "https://metamask.app.link/"
};

const WCOpenURI = props => {
  const {
    createWalletInstance,
    setConnectionStatus,
    setConnectedWallet,
    onBack,
    onConnected,
    appUriPrefix,
    onRetry,
    errorConnecting,
    hideBackButton,
    onGetStarted,
    locale,
    meta
  } = props;
  const {
    chainToConnect
  } = useWalletContext();
  const connectStarted = useRef(false);
  useEffect(() => {
    if (connectStarted.current) {
      return;
    }
    connectStarted.current = true;
    const wallet = createWalletInstance();
    setConnectionStatus("connecting");
    wallet.connectWithQrCode({
      chainId: chainToConnect?.chainId,
      onQrCodeUri(uri) {
        if (isAndroid()) {
          openWindow(`${appUriPrefix.android}wc?uri=${encodeURIComponent(uri)}`);
        } else if (isIOS()) {
          openWindow(`${appUriPrefix.ios}wc?uri=${encodeURIComponent(uri)}`);
        } else {
          openWindow(`${appUriPrefix.other}wc?uri=${encodeURIComponent(uri)}`);
        }
      },
      onConnected() {
        setConnectedWallet(wallet);
        onConnected();
      }
    });
  }, [setConnectedWallet, chainToConnect, onConnected, setConnectionStatus, appUriPrefix, createWalletInstance]);
  return /*#__PURE__*/jsx(ConnectingScreen, {
    locale: locale,
    hideBackButton: hideBackButton,
    onBack: onBack,
    walletName: meta.name,
    walletIconURL: meta.iconURL,
    errorConnecting: errorConnecting,
    onRetry: onRetry,
    onGetStarted: onGetStarted
  });
};

const MetamaskConnectUI = props => {
  const [screen, setScreen] = useState("connecting");
  const locale = useTWLocale().wallets.metamaskWallet;
  const {
    walletConfig,
    connected,
    connect
  } = props;
  const [errorConnecting, setErrorConnecting] = useState(false);
  const connectingLocale = {
    getStartedLink: locale.getStartedLink,
    instruction: locale.connectionScreen.instruction,
    tryAgain: locale.connectionScreen.retry,
    inProgress: locale.connectionScreen.inProgress,
    failed: locale.connectionScreen.failed
  };
  const hideBackButton = props.supportedWallets.length === 1;
  const connectToExtension = useCallback(async () => {
    try {
      connectPrompted.current = true;
      setErrorConnecting(false);
      setScreen("connecting");
      await wait(1000);
      await connect();
      connected();
    } catch (e) {
      setErrorConnecting(true);
      console.error(e);
    }
  }, [connected, connect]);
  const connectPrompted = useRef(false);
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }
    const isInstalled = walletConfig.isInstalled ? walletConfig.isInstalled() : false;

    // if loading
    (async () => {
      if (isInstalled) {
        connectToExtension();
      }

      // if metamask is not injected
      else {
        // on mobile, open metamask app link
        if (isMobile()) {
          if (props.connectionMethod === "walletConnect") {
            setScreen("open-wc-uri");
          } else {
            window.open(`https://metamask.app.link/dapp/${window.location.toString()}`);
          }
        } else {
          // on desktop, show the metamask scan qr code
          setScreen("scanning");
        }
      }
    })();
  }, [connectToExtension, props.connectionMethod, walletConfig]);
  if (screen === "connecting") {
    return /*#__PURE__*/jsx(ConnectingScreen, {
      locale: connectingLocale,
      errorConnecting: errorConnecting,
      onGetStarted: () => {
        setScreen("get-started");
      },
      onRetry: connectToExtension,
      hideBackButton: hideBackButton,
      onBack: props.goBack,
      walletName: walletConfig.meta.name,
      walletIconURL: walletConfig.meta.iconURL
    });
  }
  if (screen === "get-started") {
    return /*#__PURE__*/jsx(GetStartedScreen, {
      locale: {
        scanToDownload: locale.getStartedScreen.instruction
      },
      walletIconURL: walletConfig.meta.iconURL,
      walletName: walletConfig.meta.name,
      chromeExtensionLink: walletConfig.meta.urls?.chrome,
      googlePlayStoreLink: walletConfig.meta.urls?.android,
      appleStoreLink: walletConfig.meta.urls?.ios,
      onBack: props.goBack
    });
  }
  if (screen === "open-wc-uri") {
    return /*#__PURE__*/jsx(WCOpenURI, {
      locale: connectingLocale,
      onRetry: () => {
        // NOOP - TODO make onRetry optional
      },
      errorConnecting: errorConnecting,
      onGetStarted: () => {
        setScreen("get-started");
      },
      hideBackButton: hideBackButton,
      onBack: props.goBack,
      onConnected: connected,
      appUriPrefix: metamaskUris,
      createWalletInstance: props.createWalletInstance,
      setConnectedWallet: w => {
        props.setConnectedWallet(w);
      },
      setConnectionStatus: props.setConnectionStatus,
      meta: walletConfig.meta
    });
  }
  if (screen === "scanning") {
    return /*#__PURE__*/jsx(MetamaskScan, {
      onBack: props.goBack,
      onConnected: props.connected,
      onGetStarted: () => {
        setScreen("get-started");
      },
      hideBackButton: hideBackButton,
      walletConfig: walletConfig,
      setConnectedWallet: w => props.setConnectedWallet(w),
      setConnectionStatus: props.setConnectionStatus,
      createWalletInstance: props.createWalletInstance
    });
  }
  return null;
};

function handelWCSessionRequest(wallet, uris) {
  if (isMobile()) {
    wallet.on("wc_session_request_sent", () => {
      if (isAndroid()) {
        openWindow(uris.android);
      } else if (isIOS()) {
        openWindow(uris.ios);
      } else {
        openWindow(uris.other);
      }
    });
  }
}

/**
 * A wallet configurator for [MetaMask Wallet](https://metamask.io/) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * metamaskWallet({
 *   projectId: 'YOUR_PROJECT_ID',
 *   connectionMethod: 'walletConnect', // or 'metamaskBrowser',
 *   recommended: true,
 * })
 * ```
 *
 * @param options -
 * Optional configuration options for the wallet
 *
 * ### projectId (optional)
 * When connecting Core using the QR Code - Wallet Connect connector is used which requires a project id.
 * This project id is Your project’s unique identifier for wallet connect that can be obtained at cloud.walletconnect.com.
 *
 * ### recommended (optional)
 * If true, the wallet will be tagged as "recommended" in [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) Modal UI
 *
 * ### connectionMethod (optional)
 * Specify how the connection to metamask app should be established if the user is on a mobile device.
 *
 * There are two options: `"walletconnect"` and `"browser"`
 * 1. `"walletconnect"` - User will be redirected to MetaMask app and upon successful connection, user can return back to the web page.
 * 2. `"browser"` - User will be redirected to MetaMask app and the web page will be opened in MetaMask browser.
 *
 * Default is `"walletconnect"`
 *
 * @wallet
 */
const metamaskWallet = options => {
  const connectionMethod = options?.connectionMethod || "walletConnect";
  return {
    id: MetaMaskWallet.id,
    recommended: options?.recommended,
    meta: {
      ...MetaMaskWallet.meta,
      iconURL: "data:image/svg+xml;base64,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"
    },
    create: walletOptions => {
      const wallet = new MetaMaskWallet({
        ...walletOptions,
        projectId: options?.projectId,
        qrcode: false
      });
      if (connectionMethod === "walletConnect") {
        handelWCSessionRequest(wallet, metamaskUris);
      }
      return wallet;
    },
    connectUI(props) {
      return /*#__PURE__*/jsx(MetamaskConnectUI, {
        ...props,
        connectionMethod: connectionMethod
      });
    },
    isInstalled() {
      return !!getInjectedMetamaskProvider();
    }
  };
};

var metamaskWallet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  metamaskWallet: metamaskWallet
});

const TW_WC_PROJECT_ID = "145769e410f16970a79ff77b2d89a1e0";

const WalletConnectScan = props => {
  const {
    onBack,
    onConnected,
    walletConfig,
    hide,
    show,
    setConnectedWallet,
    setConnectionStatus,
    createWalletInstance
  } = props;
  const locale = useTWLocale().wallets.walletConnect;
  const [qrCodeUri, setQrCodeUri] = useState();
  const {
    chainToConnect
  } = useWalletContext();
  const [isWCModalOpen, setIsWCModalOpen] = useState(false);
  const handleWCModalConnect = async () => {
    const walletInstance = createWalletInstance();
    setConnectionStatus("connecting");
    try {
      setQrCodeUri(undefined);
      setIsWCModalOpen(true);
      wait(1000).then(() => {
        hide();
      });
      await walletInstance.connectWithModal({
        chainId: chainToConnect?.chainId
      });
      setConnectedWallet(walletInstance);
      onConnected();
      show();
    } catch {
      show();
      setIsWCModalOpen(false);
    }
  };
  return /*#__PURE__*/jsxs(Container, {
    fullHeight: true,
    animate: "fadein",
    flex: "column",
    children: [/*#__PURE__*/jsx(Container, {
      p: "lg",
      children: /*#__PURE__*/jsx(ModalHeader, {
        onBack: props.hideBackButton ? undefined : onBack,
        title: walletConfig.meta.name
      })
    }), /*#__PURE__*/jsx(Spacer, {
      y: "sm"
    }), /*#__PURE__*/jsx(Container, {
      flex: "column",
      center: "both",
      px: "lg",
      expand: true,
      children: isWCModalOpen ? /*#__PURE__*/jsx(Container, {
        style: {
          minHeight: "300px"
        },
        flex: "column",
        center: "both",
        children: /*#__PURE__*/jsx(Spinner, {
          size: "xl",
          color: "accentText"
        })
      }) : /*#__PURE__*/jsx(WalletConnectQRScanConnect, {
        createInstance: createWalletInstance,
        onConnected: onConnected,
        qrCodeUri: qrCodeUri,
        setConnectedWallet: setConnectedWallet,
        setConnectionStatus: setConnectionStatus,
        setQrCodeUri: setQrCodeUri,
        walletConfig: walletConfig,
        chainIdToConnect: chainToConnect?.chainId
      })
    }), /*#__PURE__*/jsx(Container, {
      p: "lg",
      children: /*#__PURE__*/jsx(Text, {
        multiline: true,
        center: true,
        balance: true,
        children: locale.scanInstruction
      })
    }), /*#__PURE__*/jsx(Line, {}), /*#__PURE__*/jsx(Container, {
      py: "lg",
      flex: "row",
      center: "x",
      children: /*#__PURE__*/jsx(Button, {
        variant: "link",
        onClick: handleWCModalConnect,
        children: "Open Official WalletConnect Modal"
      })
    })]
  });
};
function WalletConnectQRScanConnect(props) {
  const {
    qrCodeUri,
    walletConfig,
    onConnected,
    setConnectedWallet,
    createInstance,
    setQrCodeUri,
    chainIdToConnect,
    setConnectionStatus
  } = props;
  const scanStarted = useRef(false);
  useEffect(() => {
    if (scanStarted.current) {
      return;
    }
    scanStarted.current = true;
    const walletInstance = createInstance(walletConfig);
    setConnectionStatus("connecting");
    walletInstance.connectWithQrCode({
      chainId: chainIdToConnect,
      onQrCodeUri(uri) {
        setQrCodeUri(uri);
      },
      onConnected() {
        setConnectedWallet(walletInstance);
        onConnected();
      }
    });
  }, [createInstance, setConnectedWallet, chainIdToConnect, onConnected, walletConfig, setConnectionStatus, setQrCodeUri]);
  return /*#__PURE__*/jsx(QRCode, {
    qrCodeUri: qrCodeUri,
    QRIcon: /*#__PURE__*/jsx(Img, {
      width: iconSize.xxl,
      height: iconSize.xxl,
      src: walletConfig.meta.iconURL
    })
  });
}

// export const CopyButton: React.FC<{
//   text: string;
//   tip: string;
//   side?: "top" | "bottom" | "left" | "right";
//   align?: "start" | "center" | "end";
//   hide?: boolean;
// }> = (props) => {
//   const { hasCopied, onCopy } = useClipboard(props.text);

//   return (
//     <Button
//       variant="outline"
//       onClick={onCopy}
//       style={{
//         padding: spacing.xs,
//         fontSize: fontSize.xs,
//       }}
//     >
//       <Container flex="row" center="both" gap="xs" color="secondaryText">
//         {hasCopied ? <CheckIconStyled /> : <CopyIcon />}
//         Copy
//       </Container>
//     </Button>
//   );
// };


//   color: ${(p) => p.theme.colors.success};
// `;

const HeadlessConnectUI = props => {
  const {
    connected,
    hide,
    show,
    connect,
    setConnectionStatus,
    supportedWallets
  } = props;
  const prompted = useRef(false);
  const [connectionFailed, setConnectionFailed] = useState(false);
  const showBack = supportedWallets.length > 1;
  const handleConnect = useCallback(async () => {
    setConnectionFailed(false);
    try {
      setConnectionStatus("connecting");
      await wait(1000);
      hide();
      await connect();
      connected();
      show();
    } catch (e) {
      setConnectionStatus("disconnected");
      setConnectionFailed(true);
      show();
      console.error(e);
    }
  }, [connect, connected, hide, show, setConnectionStatus]);
  useEffect(() => {
    if (prompted.current) {
      return;
    }
    prompted.current = true;
    handleConnect();
  }, [handleConnect]);
  let content = null;
  if (connectionFailed) {
    content = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Text, {
        color: "danger",
        children: "Failed to connect"
      }), /*#__PURE__*/jsx(Spacer, {
        y: "lg"
      }), /*#__PURE__*/jsx(Button, {
        variant: "primary",
        onClick: handleConnect,
        children: "Try again"
      })]
    });
  } else {
    content = /*#__PURE__*/jsx(Spinner, {
      size: "xl",
      color: "accentText"
    });
  }
  return /*#__PURE__*/jsxs(Container, {
    p: "lg",
    children: [/*#__PURE__*/jsx(ModalHeader, {
      onBack: showBack ? props.goBack : undefined,
      title: props.walletConfig.meta.name,
      imgSrc: props.walletConfig.meta.iconURL
    }), /*#__PURE__*/jsx(Container, {
      flex: "column",
      center: "both",
      style: {
        minHeight: "250px"
      },
      children: content
    })]
  });
};

/**
 * A wallet configurator for [WalletConnect](https://walletconnect.com/) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * walletConnect({
 *   projectId: "your_project_id",
 *   qrModal: "custom", // or "walletConnect"
 *   qrModalOptions: {
 *     themeMode: "dark",
 *   },
 *   recommended: true,
 * });
 * ```
 *
 * @param config -
 * Optional configuration options for the wallet
 *
 * ### projectId (optional)
 * When connecting Trust using the QR Code - Wallet Connect connector is used which requires a project id.
 * This project id is Your project’s unique identifier for wallet connect that can be obtained at cloud.walletconnect.com.
 *
 * ### qrModal (optional)
 * Specify wheher a custom QR Modal or the Official WalletConnect Modal should be used on desktop. The custom screen has an option to open the official WalletConnect Modal too.
 *
 * Note that the official WalletConnect Modal is always used on mobile devices.
 *
 * The default is `"custom"` ( for desktop )
 *
 * ### qrModalOptions (optional)
 * The [WalletConnect Modal options](https://docs.walletconnect.com/advanced/walletconnectmodal/options) to customize the official WalletConnect Modal.
 *
 * ### recommended (optional)
 * If true, the wallet will be tagged as "recommended" in [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) Modal UI
 *
 * @wallet
 */
const walletConnect = config => {
  const projectId = config?.projectId || TW_WC_PROJECT_ID;

  // on mobile - always use the official WalletConnect Modal
  // on desktop - use the official WalletConnect Modal if qrModal is set to "walletconnect"
  const showOfficialModal = isMobile() ? true : config?.qrModal === "walletConnect" ? true : false;
  return {
    recommended: config?.recommended,
    id: WalletConnect.id,
    meta: {
      ...WalletConnect.meta,
      iconURL: "data:image/svg+xml;base64,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"
    },
    create(options) {
      return new WalletConnect({
        ...options,
        qrcode: showOfficialModal,
        projectId,
        qrModalOptions: config?.qrModalOptions
      });
    },
    connectUI(props) {
      if (showOfficialModal) {
        return /*#__PURE__*/jsx(HeadlessConnectUI, {
          ...props
        });
      }
      return /*#__PURE__*/jsx(WalletConnectScan, {
        onBack: props.goBack,
        onConnected: props.connected,
        walletConfig: props.walletConfig,
        hideBackButton: props.supportedWallets.length === 1,
        modalSize: props.modalSize,
        createWalletInstance: props.createWalletInstance,
        setConnectedWallet: props.setConnectedWallet,
        setConnectionStatus: props.setConnectionStatus,
        hide: props.hide,
        show: props.show
      });
    }
  };
};

var walletConnect$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  walletConnect: walletConnect
});

const WalletConnectScanUI = props => {
  const {
    onBack,
    onConnected,
    onGetStarted,
    hideBackButton,
    setConnectionStatus,
    setConnectedWallet,
    createWalletInstance
  } = props;
  const locale = props.walletLocale;
  const [qrCodeUri, setQrCodeUri] = useState();
  const {
    chainToConnect
  } = useWalletContext();
  const scanStarted = useRef(false);
  useEffect(() => {
    if (scanStarted.current) {
      return;
    }
    scanStarted.current = true;
    const wallet = createWalletInstance();
    wallet.connectWithQrCode({
      chainId: chainToConnect?.chainId,
      onQrCodeUri(uri) {
        setQrCodeUri(uri);
      },
      onConnected() {
        setConnectionStatus("connecting");
        setConnectedWallet(wallet);
        onConnected();
      }
    });
  }, [createWalletInstance, setConnectedWallet, chainToConnect, onConnected, setConnectionStatus]);
  return /*#__PURE__*/jsx(ScanScreen, {
    qrScanInstruction: locale.scanScreen.instruction,
    onBack: onBack,
    onGetStarted: onGetStarted,
    qrCodeUri: qrCodeUri,
    walletName: props.meta.name,
    walletIconURL: props.meta.iconURL,
    hideBackButton: hideBackButton,
    getStartedLink: locale.getStartedLink
  });
};

const ExtensionOrWCConnectionUI = props => {
  const [screen, setScreen] = useState("connecting");
  const {
    connected,
    connect,
    supportedWallets,
    isInstalled,
    meta,
    createWalletInstance,
    setConnectedWallet,
    setConnectionStatus,
    goBack,
    walletConnectUris,
    walletLocale: locale
  } = props;
  const connectingLocale = {
    getStartedLink: locale.getStartedLink,
    instruction: locale.connectionScreen.instruction,
    tryAgain: locale.connectionScreen.retry,
    inProgress: locale.connectionScreen.inProgress,
    failed: locale.connectionScreen.failed
  };
  const [errorConnecting, setErrorConnecting] = useState(false);
  const hideBackButton = supportedWallets.length === 1;
  const connectToExtension = useCallback(async () => {
    try {
      connectPrompted.current = true;
      setErrorConnecting(false);
      setScreen("connecting");
      await wait(1000);
      await connect();
      connected();
    } catch (e) {
      setErrorConnecting(true);
      console.error(e);
    }
  }, [connected, connect]);
  const connectPrompted = useRef(false);
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }
    const isInstalledVal = isInstalled ? isInstalled() : false;

    // if loading
    (async () => {
      if (isInstalledVal) {
        connectToExtension();
      }

      // if wallet is not injected
      else {
        // on mobile, open the Coin98 Mobile via wallet connect
        if (isMobile()) {
          setScreen("open-wc-uri");
        } else {
          // on desktop, show the Coin98 app scan qr code
          setScreen("scanning");
        }
      }
    })();
  }, [connectToExtension, isInstalled]);
  if (screen === "connecting") {
    return /*#__PURE__*/jsx(ConnectingScreen, {
      locale: connectingLocale,
      errorConnecting: errorConnecting,
      onGetStarted: () => {
        setScreen("get-started");
      },
      onRetry: connectToExtension,
      hideBackButton: hideBackButton,
      onBack: goBack,
      walletName: meta.name,
      walletIconURL: meta.iconURL
    });
  }
  if (screen === "open-wc-uri") {
    return /*#__PURE__*/jsx(WCOpenURI, {
      locale: connectingLocale,
      onRetry: () => {
        // NOOP - TODO make onRetry optional
      },
      errorConnecting: errorConnecting,
      onGetStarted: () => {
        setScreen("get-started");
      },
      hideBackButton: hideBackButton,
      onBack: goBack,
      onConnected: connected,
      appUriPrefix: walletConnectUris,
      createWalletInstance: createWalletInstance,
      meta: meta,
      setConnectedWallet: w => {
        setConnectedWallet(w);
      },
      setConnectionStatus: setConnectionStatus
    });
  }
  if (screen === "get-started") {
    return /*#__PURE__*/jsx(GetStartedScreen, {
      locale: {
        scanToDownload: locale.getStartedScreen.instruction
      },
      walletIconURL: meta.iconURL,
      walletName: meta.name,
      chromeExtensionLink: meta.urls?.chrome,
      googlePlayStoreLink: meta.urls?.android,
      appleStoreLink: meta.urls?.ios,
      onBack: goBack
    });
  }
  if (screen === "scanning") {
    return /*#__PURE__*/jsx(WalletConnectScanUI, {
      onBack: goBack,
      onConnected: connected,
      onGetStarted: () => {
        setScreen("get-started");
      },
      hideBackButton: hideBackButton,
      createWalletInstance: createWalletInstance,
      meta: meta,
      setConnectedWallet: w => {
        setConnectedWallet(w);
      },
      setConnectionStatus: setConnectionStatus,
      walletLocale: locale
    });
  }
  return null;
};

const trustWalletUris = {
  ios: "trust://",
  android: "https://link.trustwallet.com/",
  other: "https://link.trustwallet.com/"
};

/**
 * @wallet
 */

/**
 * A wallet configurator for [Trust Wallet](https://trustwallet.com/) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * trustWallet({
 *  projectId: 'your_project_id',
 *  recommended: true,
 * })
 * ```
 *
 * @param config -
 * Optional configuration options for the wallet
 *
 * ### projectId (optional)
 * When connecting Trust using the QR Code - Wallet Connect connector is used which requires a project id.
 * This project id is Your project’s unique identifier for wallet connect that can be obtained at cloud.walletconnect.com.
 *
 * ### recommended (optional)
 * If true, the wallet will be tagged as "recommended" in [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) Modal UI
 *
 * @wallet
 */
const trustWallet = options => {
  return {
    id: TrustWallet$1.id,
    recommended: options?.recommended,
    meta: {
      ...TrustWallet$1.meta,
      iconURL: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiByeD0iMTIiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00MC41MzAzIDE3LjE0MjVDNDguMjQ3NyAyMy42ODU3IDU3LjE1NiAyMy4zNTE4IDU5LjcwMDMgMjMuMzcwN0M1OC44Njk4IDYwLjI1MTMgNTQuNjgzNSA1Mi45MDU4IDQwLjE4ODcgNjMuMTQxMkMyNS44NDc0IDUyLjY5MTYgMjEuNTc5IDU5Ljk3NDQgMjEuMjk2NCAyMy4wODU1QzIzLjgxNDIgMjMuMTA0MiAzMi43MTY1IDIzLjU3MDQgNDAuNTMwMyAxNy4xNDI1WiIgc3Ryb2tlPSIjMzM3NUJCIiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
    },
    create: walletOptions => {
      const wallet = new TrustWallet$1({
        ...walletOptions,
        projectId: options?.projectId,
        qrcode: false
      });
      handelWCSessionRequest(wallet, trustWalletUris);
      return wallet;
    },
    connectUI: ConnectUI$2,
    isInstalled: isInstalled$2
  };
};
function isInstalled$2() {
  if (assertWindowEthereum(globalThis.window)) {
    return !!globalThis.window.ethereum.isTrust;
  }
  return false;
}
function ConnectUI$2(props) {
  const locale = useTWLocale();
  return /*#__PURE__*/jsx(ExtensionOrWCConnectionUI, {
    connect: props.connect,
    connected: props.connected,
    createWalletInstance: props.createWalletInstance,
    goBack: props.goBack,
    meta: props.walletConfig["meta"],
    setConnectedWallet: w => props.setConnectedWallet(w),
    setConnectionStatus: props.setConnectionStatus,
    supportedWallets: props.supportedWallets,
    walletConnectUris: trustWalletUris,
    walletLocale: locale.wallets.trustWallet,
    isInstalled: isInstalled$2
  });
}

var TrustWallet = /*#__PURE__*/Object.freeze({
  __proto__: null,
  trustWallet: trustWallet
});

const zerionWalletUris = {
  ios: "zerion://",
  android: "https://link.zerion.io/pt3gdRP0njb/",
  other: "https://link.zerion.io/pt3gdRP0njb/"
};

/**
 * @wallet
 */

/**
 * A wallet configurator for [Zerion Wallet](https://zerion.io/) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * zerionWallet({
 *  projectId: "your_project_id",
 *  recommended: true,
 * })
 * ```
 *
 * @param options -
 * Optional configuration options for the wallet
 *
 * ### projectId (optional)
 * When connecting MetaMask using the QR Code - Wallet Connect connector is used which requires a project id.
 * This project id is Your project’s unique identifier for wallet connect that can be obtained at cloud.walletconnect.com.
 *
 * ### recommended (optional)
 * If true, the wallet will be tagged as "recommended" in ConnectWallet Modal
 *
 * @wallet
 */
const zerionWallet = options => {
  return {
    id: ZerionWallet.id,
    recommended: options?.recommended,
    meta: {
      ...ZerionWallet.meta,
      iconURL: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiByeD0iMTIiIGZpbGw9IiMyMzYxRUMiLz4KPHBhdGggZD0iTTE3LjM3OSAyMEMxNi4wMDggMjAgMTUuNDc5OCAyMS42OTUyIDE2LjYzMDEgMjIuNDAzNEw0NS40MDk0IDM5Ljc1NjJDNDYuMTI2OCA0MC4xOTc4IDQ3LjA4MzUgNDAuMDIzNCA0Ny41Nzc0IDM5LjM2MDhMNjAuMjMwOSAyMi43NDlDNjEuMDkxMiAyMS41OTUgNjAuMjIyIDIwIDU4LjczMjkgMjBIMTcuMzc5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTYyLjYxMTcgNjAuMDAwMUM2My45ODI3IDYwLjAwMDEgNjQuNTI0NSA1OC4yOTU1IDYzLjM3NDMgNTcuNTg3NUwzNC41ODY4IDQwLjIzNjlDMzMuODY5NCAzOS43OTUzIDMyLjkzNTkgMzkuOTkxOSAzMi40NDIxIDQwLjY1NDNMMTkuNzY0IDU3LjI2MjlDMTguOTAzOSA1OC40MTY3IDE5LjgwMDMgNjAuMDAwMSAyMS4yODkyIDYwLjAwMDFINjIuNjExN1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
    },
    create: walletOptions => {
      const wallet = new ZerionWallet({
        ...walletOptions,
        projectId: options?.projectId,
        qrcode: false
      });
      handelWCSessionRequest(wallet, zerionWalletUris);
      return wallet;
    },
    connectUI: ConnectUI$1,
    isInstalled: isInstalled$1
  };
};
function isInstalled$1() {
  if (assertWindowEthereum(globalThis.window)) {
    return !!globalThis.window.ethereum.isZerion;
  }
  return false;
}
function ConnectUI$1(props) {
  const locale = useTWLocale();
  return /*#__PURE__*/jsx(ExtensionOrWCConnectionUI, {
    connect: props.connect,
    connected: props.connected,
    createWalletInstance: props.createWalletInstance,
    goBack: props.goBack,
    meta: props.walletConfig["meta"],
    setConnectedWallet: w => props.setConnectedWallet(w),
    setConnectionStatus: props.setConnectionStatus,
    supportedWallets: props.supportedWallets,
    walletConnectUris: zerionWalletUris,
    walletLocale: locale.wallets.zerionWallet,
    isInstalled: isInstalled$1
  });
}

const rainbowWalletUris = {
  ios: "rainbow://",
  android: "https://rnbwapp.com/",
  other: "https://rnbwapp.com/"
};

/**
 * @wallet
 */

/**
 * A wallet configurator for [Rainbow Wallet](https://rainbow.me/en/) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * rainbowWallet({
 *  projectId: 'YOUR_PROJECT_ID',
 *  recommended: true,
 * })
 * ```
 *
 * @param options -
 * Optional configuration options for the wallet
 *
 * ### projectId (optional)
 * When connecting Core using the QR Code - Wallet Connect connector is used which requires a project id.
 * This project id is Your project’s unique identifier for wallet connect that can be obtained at cloud.walletconnect.com.
 *
 * ### recommended (optional)
 * If true, the wallet will be tagged as "recommended" in [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) Modal UI
 *
 * @wallet
 */
const rainbowWallet = options => {
  return {
    id: RainbowWallet$1.id,
    recommended: options?.recommended,
    meta: {
      ...RainbowWallet$1.meta,
      name: "Rainbow",
      iconURL: "data:image/svg+xml;base64,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"
    },
    create: walletOptions => {
      const wallet = new RainbowWallet$1({
        ...walletOptions,
        projectId: options?.projectId,
        qrcode: false
      });
      handelWCSessionRequest(wallet, rainbowWalletUris);
      return wallet;
    },
    connectUI: ConnectUI,
    isInstalled: isInstalled
  };
};
function isInstalled() {
  return !!getInjectedRainbowProvider();
}
function ConnectUI(props) {
  const locale = useTWLocale();
  return /*#__PURE__*/jsx(ExtensionOrWCConnectionUI, {
    connect: props.connect,
    connected: props.connected,
    createWalletInstance: props.createWalletInstance,
    goBack: props.goBack,
    meta: props.walletConfig["meta"],
    setConnectedWallet: w => props.setConnectedWallet(w),
    setConnectionStatus: props.setConnectionStatus,
    supportedWallets: props.supportedWallets,
    walletConnectUris: rainbowWalletUris,
    walletLocale: locale.wallets.rainbowWallet,
    isInstalled: isInstalled
  });
}

var RainbowWallet = /*#__PURE__*/Object.freeze({
  __proto__: null,
  rainbowWallet: rainbowWallet
});

const PhantomConnectUI = props => {
  const [screen, setScreen] = useState("connecting");
  const locale = useTWLocale().wallets.phantomWallet;
  const {
    walletConfig,
    connected
  } = props;
  const [errorConnecting, setErrorConnecting] = useState(false);
  const {
    connect
  } = props;
  const hideBackButton = props.supportedWallets.length === 1;
  const {
    goBack
  } = props;
  const connectToExtension = useCallback(async () => {
    try {
      connectPrompted.current = true;
      setScreen("connecting");
      setErrorConnecting(false);
      await wait(1000);
      await connect();
      connected();
    } catch (e) {
      setErrorConnecting(true);
      console.error(e);
    }
  }, [connected, connect]);
  const connectPrompted = useRef(false);
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }
    const isInstalled = walletConfig.isInstalled ? walletConfig.isInstalled() : false;
    (async () => {
      if (isInstalled) {
        connectToExtension();
      }

      // if phantom is not injected
      else {
        setScreen("get-started");
      }
    })();
  }, [walletConfig, connected, connect, goBack, connectToExtension]);
  if (screen === "connecting") {
    return /*#__PURE__*/jsx(ConnectingScreen, {
      locale: {
        getStartedLink: locale.getStartedLink,
        instruction: locale.connectionScreen.instruction,
        tryAgain: locale.connectionScreen.retry,
        inProgress: locale.connectionScreen.inProgress,
        failed: locale.connectionScreen.failed
      },
      hideBackButton: hideBackButton,
      onBack: props.goBack,
      walletName: walletConfig.meta.name,
      walletIconURL: walletConfig.meta.iconURL,
      onGetStarted: () => {
        setScreen("get-started");
      },
      onRetry: () => {
        connectToExtension();
      },
      errorConnecting: errorConnecting
    });
  }
  if (screen === "get-started") {
    return /*#__PURE__*/jsx(GetStartedScreen, {
      locale: {
        scanToDownload: locale.getStartedScreen.instruction
      },
      walletIconURL: walletConfig.meta.iconURL,
      walletName: walletConfig.meta.name,
      chromeExtensionLink: walletConfig.meta.urls?.chrome,
      googlePlayStoreLink: walletConfig.meta.urls?.android,
      appleStoreLink: walletConfig.meta.urls?.ios,
      onBack: () => {
        props.goBack();
      }
    });
  }
  return null;
};

/**
 * @wallet
 */

/**
 * A wallet configurator for [Phantom Wallet](https://phantom.app/) which allows integrating the wallet with React.
 *
 * It returns a [`WalletConfig`](https://portal.thirdweb.com/references/react/v4/WalletConfig) object which can be used to connect the wallet to via [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) component or [`useConnect`](https://portal.thirdweb.com/references/react/v4/useConnect) hook as mentioned in [Connecting Wallets](https://portal.thirdweb.com/react/v4/connecting-wallets) guide
 *
 * @example
 * ```ts
 * phantomWallet({
 *  recommended: true,
 * })
 * ```
 *
 * @param options -
 * Optional configuration options for the wallet
 *
 * ### recommended (optional)
 * If `true`, the wallet will be tagged as "recommended" in [`ConnectWallet`](https://portal.thirdweb.com/react/v4/components/ConnectWallet) Modal UI. Default is `false`
 *
 * @wallet
 */
const phantomWallet = options => {
  return {
    recommended: options?.recommended,
    id: PhantomWallet.id,
    meta: {
      ...PhantomWallet.meta,
      iconURL: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiB2aWV3Qm94PSIwIDAgMTA4IDEwOCIgZmlsbD0ibm9uZSI+CjxyZWN0IHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiByeD0iMjYiIGZpbGw9IiNBQjlGRjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ni41MjY3IDY5LjkyMjlDNDIuMDA1NCA3Ni44NTA5IDM0LjQyOTIgODUuNjE4MiAyNC4zNDggODUuNjE4MkMxOS41ODI0IDg1LjYxODIgMTUgODMuNjU2MyAxNSA3NS4xMzQyQzE1IDUzLjQzMDUgNDQuNjMyNiAxOS44MzI3IDcyLjEyNjggMTkuODMyN0M4Ny43NjggMTkuODMyNyA5NCAzMC42ODQ2IDk0IDQzLjAwNzlDOTQgNTguODI1OCA4My43MzU1IDc2LjkxMjIgNzMuNTMyMSA3Ni45MTIyQzcwLjI5MzkgNzYuOTEyMiA2OC43MDUzIDc1LjEzNDIgNjguNzA1MyA3Mi4zMTRDNjguNzA1MyA3MS41NzgzIDY4LjgyNzUgNzAuNzgxMiA2OS4wNzE5IDY5LjkyMjlDNjUuNTg5MyA3NS44Njk5IDU4Ljg2ODUgODEuMzg3OCA1Mi41NzU0IDgxLjM4NzhDNDcuOTkzIDgxLjM4NzggNDUuNjcxMyA3OC41MDYzIDQ1LjY3MTMgNzQuNDU5OEM0NS42NzEzIDcyLjk4ODQgNDUuOTc2OCA3MS40NTU2IDQ2LjUyNjcgNjkuOTIyOVpNODMuNjc2MSA0Mi41Nzk0QzgzLjY3NjEgNDYuMTcwNCA4MS41NTc1IDQ3Ljk2NTggNzkuMTg3NSA0Ny45NjU4Qzc2Ljc4MTYgNDcuOTY1OCA3NC42OTg5IDQ2LjE3MDQgNzQuNjk4OSA0Mi41Nzk0Qzc0LjY5ODkgMzguOTg4NSA3Ni43ODE2IDM3LjE5MzEgNzkuMTg3NSAzNy4xOTMxQzgxLjU1NzUgMzcuMTkzMSA4My42NzYxIDM4Ljk4ODUgODMuNjc2MSA0Mi41Nzk0Wk03MC4yMTAzIDQyLjU3OTVDNzAuMjEwMyA0Ni4xNzA0IDY4LjA5MTYgNDcuOTY1OCA2NS43MjE2IDQ3Ljk2NThDNjMuMzE1NyA0Ny45NjU4IDYxLjIzMyA0Ni4xNzA0IDYxLjIzMyA0Mi41Nzk1QzYxLjIzMyAzOC45ODg1IDYzLjMxNTcgMzcuMTkzMSA2NS43MjE2IDM3LjE5MzFDNjguMDkxNiAzNy4xOTMxIDcwLjIxMDMgMzguOTg4NSA3MC4yMTAzIDQyLjU3OTVaIiBmaWxsPSIjRkZGREY4Ii8+Cjwvc3ZnPgo="
    },
    create: walletOptions => new PhantomWallet(walletOptions),
    connectUI: PhantomConnectUI,
    isInstalled() {
      return !!getInjectedPhantomProvider();
    }
  };
};

/**
 * The default wallets that are used by the [`ThirdwebProvider`](https://portal.thirdweb.com/react/v4/ThirdwebProvider) if no `supportedWallets` prop is provided.
 *
 * The defaults wallets are:
 * - Metamask
 * - Coinbase
 * - WalletConnect
 * - TrustWallet
 * - RainbowWallet
 * - ZerionWallet
 * - PhantomWallet
 */
const defaultWallets = /* @__PURE__ */(() => [metamaskWallet(), coinbaseWallet(), walletConnect(), trustWallet(), rainbowWallet(), zerionWallet(), phantomWallet()])();

const TWIcon = props => {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 27 16",
    fill: "none",
    children: [/*#__PURE__*/jsx("path", {
      d: "M13.6891 0C13.8482 0.0317795 13.9983 0.0957213 14.1292 0.1875C14.2768 0.297724 14.39 0.444328 14.4563 0.611413C14.8718 1.60272 15.2885 2.59348 15.7064 3.5837L17.0986 6.89022C17.3418 7.46902 17.5832 8.0462 17.8298 8.62337C17.8823 8.74121 17.9094 8.86791 17.9094 8.99592C17.9094 9.12393 17.8823 9.25064 17.8298 9.36848C17.1243 11.0446 16.4182 12.7217 15.7115 14.4C15.654 14.5572 15.5516 14.696 15.4157 14.8009C15.2799 14.9057 15.1161 14.9724 14.9426 14.9935C14.7283 15.0315 14.5068 14.9982 14.3153 14.899C14.1238 14.7998 13.9741 14.6409 13.8912 14.4489C13.4939 13.5196 13.1052 12.587 12.713 11.6543C12.0463 10.075 11.3813 8.49456 10.718 6.91304C10.1255 5.50543 9.5336 4.09891 8.94223 2.69348C8.7453 2.22717 8.55522 1.75761 8.34973 1.29293C8.29321 1.16705 8.26644 1.03087 8.27132 0.894047C8.27619 0.757221 8.31259 0.623087 8.37794 0.501137C8.44329 0.379187 8.53599 0.272402 8.64948 0.188339C8.76297 0.104275 8.89448 0.0449885 9.03471 0.0146733C9.05183 0.0146733 9.06724 0.0048913 9.08437 0H13.6891Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.42129 0C5.47438 0.0146739 5.52575 0.0260873 5.57712 0.0423917C5.71022 0.0819151 5.83236 0.14928 5.93458 0.239555C6.0368 0.329829 6.11653 0.440727 6.16791 0.56413C6.62457 1.63913 7.07779 2.71413 7.52759 3.78913C7.97739 4.86413 8.43404 5.95109 8.89755 7.05L9.57053 8.64456C9.62093 8.75806 9.6469 8.88004 9.6469 9.00326C9.6469 9.12648 9.62093 9.24846 9.57053 9.36196C9.32052 9.9587 9.06936 10.5565 8.81706 11.1554L7.43512 14.431C7.36255 14.6012 7.23853 14.7471 7.07879 14.8501C6.91904 14.9532 6.73075 15.0087 6.5378 15.0098C6.33426 15.0125 6.13478 14.9554 5.96654 14.8463C5.7983 14.7372 5.6695 14.5814 5.59767 14.4C5.16956 13.3712 4.74145 12.344 4.30307 11.3168L2.54781 7.14946L0.763448 2.91033C0.539118 2.37554 0.314789 1.83913 0.0784718 1.30435C-0.0212674 1.08161 -0.026107 0.830668 0.0649731 0.604591C0.156053 0.378515 0.335913 0.195028 0.566519 0.0929347C0.650596 0.0604572 0.73701 0.0337587 0.825096 0.0130438L5.42129 0Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M26.0098 9.14348C25.8865 9.54782 25.7067 9.92935 25.5355 10.3239C25.0708 11.4315 24.6033 12.5397 24.133 13.6484C24.0251 13.9109 23.9155 14.1554 23.811 14.4114C23.7364 14.591 23.605 14.744 23.4351 14.8495C23.2651 14.9549 23.065 15.0075 22.8623 15C22.6689 14.995 22.4813 14.9353 22.3237 14.8284C22.166 14.7216 22.0453 14.5724 21.977 14.4C21.2989 12.7848 20.6196 11.1696 19.9392 9.55435C19.3524 8.16522 18.7633 6.77283 18.172 5.37717C17.6011 4.01087 17.0303 2.64456 16.4595 1.27826C16.4042 1.15338 16.3784 1.01844 16.3839 0.882999C16.3895 0.747561 16.4262 0.614939 16.4916 0.494528C16.5569 0.374117 16.6493 0.268861 16.7621 0.186219C16.875 0.103577 17.0055 0.0455688 17.1445 0.0163041L17.201 0H21.8023L21.8451 0.0130438C22.0073 0.0455066 22.158 0.116718 22.2833 0.219974C22.4085 0.32323 22.504 0.455132 22.5609 0.60326C22.8281 1.23913 23.0964 1.87554 23.3658 2.5125C24.0679 4.18206 24.77 5.85163 25.4721 7.52119C25.657 7.96141 25.8625 8.39348 26.0132 8.84511L26.0098 9.14348Z",
      fill: "currentColor"
    })]
  });
};

function TOS(props) {
  const {
    termsOfServiceUrl,
    privacyPolicyUrl
  } = props;
  const locale = useTWLocale().connectWallet.agreement;
  if (!termsOfServiceUrl && !privacyPolicyUrl) {
    return null;
  }
  const bothGiven = termsOfServiceUrl && privacyPolicyUrl;
  return /*#__PURE__*/jsx(Container, {
    flex: "row",
    center: "x",
    children: /*#__PURE__*/jsxs(Text, {
      size: "xs",
      multiline: true,
      balance: true,
      inline: true,
      center: true,
      style: {
        maxWidth: "250px"
      },
      children: [locale.prefix, " ", termsOfServiceUrl && /*#__PURE__*/jsxs(Link, {
        inline: true,
        size: "xs",
        href: termsOfServiceUrl,
        target: "_blank",
        style: {
          whiteSpace: "nowrap"
        },
        children: [" ", locale.termsOfService, " "]
      }), bothGiven && locale.and + " ", privacyPolicyUrl && /*#__PURE__*/jsx(Link, {
        inline: true,
        size: "xs",
        href: privacyPolicyUrl,
        target: "_blank",
        children: locale.privacyPolicy
      })]
    })
  });
}

const ThirdwebTextIcon = props => {
  return /*#__PURE__*/jsxs("svg", {
    width: props.height * 74 / 11,
    height: props.height,
    viewBox: "0 0 74 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34.1489 0.373291C33.5297 0.373291 33.022 0.874761 33.022 1.51414C33.022 2.14097 33.5297 2.64244 34.1489 2.64244C34.7681 2.64244 35.2758 2.14097 35.2758 1.51414C35.2758 0.874761 34.7681 0.373291 34.1489 0.373291ZM35.1396 3.21913H33.1706V9.97644H35.1396V3.21913ZM21.6787 0.624035H23.5982V3.21914H25.0718V5.02444H23.5982V7.40642C23.5982 7.75745 23.8706 8.03326 24.205 8.03326H25.0594V9.95138H24.205C22.818 9.95138 21.6787 8.81054 21.6787 7.39389V5.0119H20.7871V3.20661H21.6787V0.624035ZM29.7652 3.0687C28.8736 3.0687 28.1677 3.44481 27.8953 4.03403V0.624035H25.9263V9.96392H27.8953V6.17782C27.8953 5.388 28.403 4.83639 29.1213 4.83639C29.8519 4.83639 30.2605 5.31278 30.2605 6.11514V9.97646H32.2295V5.8644C32.2295 4.10925 31.3379 3.0687 29.7652 3.0687ZM37.9507 3.2066V4.13432C38.2479 3.45734 38.9661 3.0687 39.8701 3.05616C40.0063 3.05616 40.1797 3.0687 40.3902 3.09377V4.97429C40.1921 4.93668 39.9692 4.9116 39.7339 4.9116C38.607 4.9116 37.9507 5.55098 37.9507 6.66675V9.96392H35.9817V3.2066H37.9507ZM45.9257 4.09672C45.7275 3.50749 44.9474 3.09378 43.9443 3.09378C43.0032 3.09378 42.2106 3.43227 41.5791 4.10926C40.9599 4.7737 40.6379 5.61367 40.6379 6.59154C40.6379 7.5694 40.9599 8.39683 41.5791 9.08635C42.2106 9.7508 43.0032 10.0893 43.9443 10.0893C44.9474 10.0893 45.7275 9.67558 45.9257 9.08635V9.97646H47.8946V0.624035H45.9257V4.09672ZM45.5294 7.79506C45.195 8.12102 44.7864 8.27146 44.3034 8.27146C43.8329 8.27146 43.4242 8.10848 43.1022 7.79506C42.7679 7.45657 42.6069 7.0554 42.6069 6.59154C42.6069 6.12767 42.7679 5.7265 43.1022 5.40054C43.4366 5.06205 43.8329 4.89907 44.3034 4.89907C44.7988 4.89907 45.2074 5.06205 45.5294 5.40054C45.8761 5.7265 46.0495 6.12767 46.0495 6.59154C46.0495 7.0554 45.8761 7.45657 45.5294 7.79506ZM53.5787 3.2442L55.3619 6.45361L56.5631 3.21913H58.4949L55.7458 10.3651L53.5787 6.47868L51.4115 10.3651L48.6748 3.21913H50.6066L51.7954 6.45361L53.5787 3.2442ZM61.7394 3.05616C60.7239 3.05616 59.8694 3.38212 59.2007 4.03403C58.5444 4.6734 58.2101 5.5259 58.2101 6.57899V6.64167C58.2101 7.69476 58.5444 8.54726 59.2007 9.18664C59.8818 9.81347 60.7487 10.1394 61.8384 10.1394C62.8539 10.1394 63.6836 9.93884 64.3151 9.52513V7.78252C63.6959 8.22131 62.9034 8.43443 61.9499 8.43443C60.9097 8.43443 60.2286 7.92042 60.1914 7.11807H65.0829C65.1077 6.91748 65.12 6.69182 65.12 6.46616C65.12 5.50083 64.7981 4.69848 64.1789 4.04657C63.5597 3.38212 62.73 3.05616 61.7394 3.05616ZM60.1914 5.82679C60.2038 5.51337 60.3648 5.25009 60.662 5.03697C60.9716 4.82385 61.3183 4.71101 61.7394 4.71101C62.5195 4.71101 63.1263 5.22502 63.1263 5.82679H60.1914ZM69.8135 3.09378C70.7546 3.09378 71.5472 3.43227 72.1663 4.10925C72.7979 4.78624 73.1199 5.60113 73.1199 6.579C73.1199 7.55686 72.7979 8.38429 72.1663 9.07381C71.5472 9.73826 70.7546 10.0768 69.8135 10.0768C68.8104 10.0768 68.0302 9.66304 67.8321 9.07381V9.96392H65.8631V0.624035H67.8321V4.09672C68.0302 3.50749 68.8104 3.09378 69.8135 3.09378ZM69.4543 8.27146C69.9249 8.27146 70.3212 8.12102 70.6555 7.79506C70.9899 7.45657 71.1509 7.05539 71.1509 6.59153C71.1509 6.12767 70.9899 5.7265 70.6555 5.40054C70.3336 5.06205 69.9249 4.89907 69.4543 4.89907C68.9714 4.89907 68.5627 5.06205 68.216 5.40054C67.8816 5.7265 67.7083 6.12767 67.7083 6.59153C67.7083 7.05539 67.8816 7.45657 68.216 7.79506C68.5503 8.10848 68.959 8.27146 69.4543 8.27146Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("g", {
      clipPath: "url(#clip0_5017_2727)",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.045011 0.900694C-0.126602 0.467742 0.193222 0 0.661257 0H3.56697C3.83999 0 4.08181 0.162357 4.18322 0.413623L6.49609 6.18115C6.55849 6.33578 6.55849 6.50973 6.49609 6.66822L5.04128 10.2903C4.81896 10.8431 4.03111 10.8431 3.80879 10.2903L0.045011 0.900694ZM5.65759 0.881366C5.50158 0.45228 5.8214 0 6.28164 0H8.81292C9.09374 0 9.34336 0.173954 9.43697 0.432951L11.5392 6.20048C11.5899 6.34351 11.5899 6.502 11.5392 6.6489L10.2755 10.1164C10.0649 10.6962 9.23805 10.6962 9.02744 10.1164L5.65759 0.881366ZM11.3404 0C10.8724 0 10.5525 0.467742 10.7241 0.900694L14.4879 10.2903C14.7102 10.8431 15.4981 10.8431 15.7204 10.2903L17.1752 6.66822C17.2376 6.50973 17.2376 6.33578 17.1752 6.18115L14.8623 0.413623C14.7609 0.162357 14.5191 0 14.2461 0H11.3404Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("clipPath", {
        id: "clip0_5017_2727",
        children: /*#__PURE__*/jsx("rect", {
          width: "17.219",
          height: "10.7049",
          fill: "white"
        })
      })
    })]
  });
};

function PoweredByThirdweb() {
  return /*#__PURE__*/jsx(Link, {
    color: "secondaryText",
    hoverColor: "primaryText",
    target: "_blank",
    href: "https://thirdweb.com/connect?utm_source=cw_text",
    children: /*#__PURE__*/jsxs(Container, {
      flex: "row",
      center: "both",
      style: {
        color: "currentColor",
        gap: 4
      },
      children: [/*#__PURE__*/jsx(Text, {
        size: "sm",
        weight: 600,
        style: {
          color: "currentColor"
        },
        children: "Powered by"
      }), /*#__PURE__*/jsx(ThirdwebTextIcon, {
        height: 13
      })]
    })
  });
}

const WalletSelector = props => {
  const modalConfig = useContext(ModalConfigCtx);
  const isCompact = modalConfig.modalSize === "compact";
  const {
    termsOfServiceUrl,
    privacyPolicyUrl
  } = modalConfig;
  const [isWalletGroupExpanded, setIsWalletGroupExpanded] = useState(false);
  const disconnect = useDisconnect();
  const connectionStatus = useConnectionStatus();
  const locale = useTWLocale().connectWallet;
  const localWalletConfig = props.walletConfigs.find(w => w.id === walletIds.localWallet);
  const nonLocalWalletConfigs = props.walletConfigs.filter(w => w.id !== walletIds.localWallet);
  const socialWallets = nonLocalWalletConfigs.filter(w => w.category === "socialLogin");
  const eoaWallets = sortWalletConfigs(nonLocalWalletConfigs.filter(w => w.category !== "socialLogin"));
  const continueAsGuest = localWalletConfig && /*#__PURE__*/jsx(Button, {
    fullWidth: true,
    variant: isCompact ? "outline" : "link",
    style: !isCompact ? {
      textAlign: "left",
      justifyContent: "flex-start"
    } : undefined,
    onClick: () => {
      props.selectWallet(localWalletConfig);
    },
    "data-test": "continue-as-guest-button",
    children: locale.continueAsGuest
  });

  // prevent accidental clicks on the TW icon when clicking on back icon from previous screen
  const enableTWIconLink = useRef(false);
  useEffect(() => {
    setTimeout(() => {
      enableTWIconLink.current = true;
    }, 1000);
  }, []);
  const twTitle = /*#__PURE__*/jsxs(Container, {
    gap: "xxs",
    center: "y",
    flex: "row",
    children: [modalConfig.titleIconUrl === undefined ? /*#__PURE__*/jsx(Link, {
      color: "primaryText",
      hoverColor: "accentText",
      target: "_blank",
      href: "https://thirdweb.com/connect?utm_source=cw",
      style: {
        display: "flex",
        alignItems: "center"
      },
      onClick: e => {
        if (!enableTWIconLink.current) {
          e.preventDefault();
        }
      },
      children: /*#__PURE__*/jsx(TWIcon, {
        size: iconSize.md
      })
    }) : modalConfig.titleIconUrl === "" ? null : /*#__PURE__*/jsx(Img, {
      src: modalConfig.titleIconUrl,
      width: iconSize.md,
      height: iconSize.md
    }), /*#__PURE__*/jsxs(ModalTitle, {
      children: [" ", props.title, " "]
    })]
  });
  const handleSelect = async wallet => {
    if (connectionStatus !== "disconnected") {
      await disconnect();
    }
    props.selectWallet(wallet);
  };
  const connectAWallet = /*#__PURE__*/jsxs(Button, {
    fullWidth: true,
    variant: "outline",
    style: {
      display: "flex",
      justifyContent: "center",
      gap: spacing.sm,
      padding: spacing.md
    },
    onClick: () => {
      setIsWalletGroupExpanded(true);
    },
    children: [/*#__PURE__*/jsx(Container, {
      flex: "row",
      gap: "xxs",
      children: eoaWallets.slice(0, 2).map(w => /*#__PURE__*/jsx(Img, {
        width: iconSize.sm,
        height: iconSize.sm,
        src: w.meta.iconURL
      }, w.id))
    }), locale.connectAWallet]
  });
  const newToWallets = /*#__PURE__*/jsxs(Container, {
    flex: "row",
    style: {
      justifyContent: "space-between"
    },
    children: [/*#__PURE__*/jsx(Text, {
      color: "secondaryText",
      size: "sm",
      weight: 500,
      children: locale.newToWallets
    }), /*#__PURE__*/jsx(Link, {
      weight: 500,
      size: "sm",
      target: "_blank",
      href: "https://blog.thirdweb.com/web3-wallet/",
      children: locale.getStarted
    })]
  });
  const tos = termsOfServiceUrl || privacyPolicyUrl ? /*#__PURE__*/jsx(TOS, {
    termsOfServiceUrl: termsOfServiceUrl,
    privacyPolicyUrl: privacyPolicyUrl
  }) : undefined;
  let topSection;
  let bottomSection;

  // wide modal
  if (!isCompact) {
    topSection = /*#__PURE__*/jsx(WalletSelection, {
      walletConfigs: nonLocalWalletConfigs,
      selectWallet: handleSelect,
      selectUIProps: props.selectUIProps
    });
    if (continueAsGuest) {
      bottomSection = /*#__PURE__*/jsx(ScreenBottomContainer, {
        children: continueAsGuest
      });
    }
  }

  // compact
  else {
    // no social logins
    if (socialWallets.length === 0) {
      topSection = /*#__PURE__*/jsx(WalletSelection, {
        walletConfigs: nonLocalWalletConfigs,
        selectWallet: handleSelect,
        selectUIProps: props.selectUIProps
      });
      bottomSection = /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Line, {}), /*#__PURE__*/jsxs(Container, {
          flex: "column",
          p: "lg",
          gap: "lg",
          children: [newToWallets, continueAsGuest]
        }), !continueAsGuest && /*#__PURE__*/jsx(Line, {}), tos && /*#__PURE__*/jsx(Container, {
          px: "md",
          style: {
            paddingBottom: spacing.md,
            paddingTop: continueAsGuest ? 0 : spacing.md
          },
          children: tos
        })]
      });
    }

    // social logins
    else {
      // not expanded state
      if (!isWalletGroupExpanded) {
        topSection = /*#__PURE__*/jsxs(Container, {
          px: "xs",
          children: [/*#__PURE__*/jsx(WalletSelection, {
            walletConfigs: socialWallets,
            selectWallet: handleSelect,
            selectUIProps: props.selectUIProps
          }), eoaWallets.length > 0 && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(TextDivider, {
              text: locale.or
            }), /*#__PURE__*/jsx(Spacer, {
              y: "lg"
            })]
          })]
        });

        // only social login - no eoa wallets
        if (eoaWallets.length === 0) {
          bottomSection = tos || continueAsGuest ? /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(Spacer, {
              y: "md"
            }), /*#__PURE__*/jsx(Line, {}), continueAsGuest && /*#__PURE__*/jsxs(Container, {
              p: "lg",
              children: [" ", continueAsGuest]
            }), tos && /*#__PURE__*/jsxs(Container, {
              p: "md",
              children: [" ", tos, " "]
            })]
          }) : /*#__PURE__*/jsx(Spacer, {
            y: "sm"
          });
        }

        // social login + eoa wallets
        else {
          // social login + More than 1 eoa wallets
          if (eoaWallets.length > 1) {
            bottomSection = /*#__PURE__*/jsxs(Container, {
              flex: "column",
              gap: "sm",
              children: [/*#__PURE__*/jsxs(Container, {
                px: "lg",
                flex: "column",
                gap: "md",
                children: [connectAWallet, continueAsGuest]
              }), tos ? /*#__PURE__*/jsxs(Container, {
                p: "md",
                children: [" ", tos, " "]
              }) : /*#__PURE__*/jsx(Spacer, {
                y: "md"
              })]
            });
          }

          // social login + single eoa wallet
          else {
            bottomSection = /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(Container, {
                px: "lg",
                children: /*#__PURE__*/jsx(WalletSelection, {
                  walletConfigs: eoaWallets,
                  selectWallet: handleSelect,
                  selectUIProps: props.selectUIProps
                })
              }), continueAsGuest && /*#__PURE__*/jsx(Container, {
                flex: "column",
                px: "lg",
                gap: "lg",
                children: continueAsGuest
              }), tos ? /*#__PURE__*/jsxs(Fragment, {
                children: [continueAsGuest ? /*#__PURE__*/jsx(Spacer, {
                  y: "md"
                }) : /*#__PURE__*/jsx(Line, {}), /*#__PURE__*/jsxs(Container, {
                  p: "md",
                  children: [" ", tos, " "]
                })]
              }) : /*#__PURE__*/jsx(Fragment, {
                children: continueAsGuest && /*#__PURE__*/jsx(Spacer, {
                  y: "xl"
                })
              })]
            });
          }
        }
      }

      // expanded state
      else {
        topSection = /*#__PURE__*/jsx(WalletSelection, {
          walletConfigs: eoaWallets,
          selectWallet: handleSelect,
          selectUIProps: props.selectUIProps
        });
        bottomSection = /*#__PURE__*/jsx(ScreenBottomContainer, {
          children: newToWallets
        });
      }
    }
  }
  return /*#__PURE__*/jsxs(Container, {
    scrollY: true,
    flex: "column",
    animate: "fadein",
    fullHeight: true,
    children: [!modalConfig.isEmbed && /*#__PURE__*/jsx(Container, {
      p: "lg",
      style: {
        paddingBottom: spacing.md
      },
      children: isWalletGroupExpanded ? /*#__PURE__*/jsx(ModalHeader, {
        title: twTitle,
        onBack: () => {
          setIsWalletGroupExpanded(false);
        }
      }) : twTitle
    }), /*#__PURE__*/jsxs(Container, {
      expand: true,
      scrollY: true,
      px: "md",
      style: modalConfig.isEmbed ? {
        paddingTop: spacing.lg
      } : {
        paddingTop: "2px"
      },
      children: [modalConfig.isEmbed && isWalletGroupExpanded && /*#__PURE__*/jsx(Container, {
        flex: "row",
        center: "y",
        style: {
          padding: spacing.sm,
          paddingTop: 0
        },
        children: /*#__PURE__*/jsxs(IconButton, {
          onClick: () => {
            setIsWalletGroupExpanded(false);
          },
          style: {
            gap: spacing.xxs,
            transform: `translateX(-${spacing.xs})`,
            paddingBlock: spacing.xxs,
            paddingRight: spacing.xs
          },
          children: [/*#__PURE__*/jsx(ChevronLeftIcon, {
            width: iconSize.sm,
            height: iconSize.sm
          }), locale.goBackButton]
        })
      }), topSection]
    }), /*#__PURE__*/jsxs("div", {
      children: [bottomSection, isCompact && modalConfig.showThirdwebBranding !== false && /*#__PURE__*/jsx(Container, {
        py: "md",
        children: /*#__PURE__*/jsx(PoweredByThirdweb, {})
      })]
    })]
  });
};
const WalletSelection = props => {
  const modalConfig = useContext(ModalConfigCtx);
  const setModalConfig = useContext(SetModalConfigCtx);
  const walletConfigs = sortWalletConfigs(props.walletConfigs);
  return /*#__PURE__*/jsx(WalletList, {
    children: walletConfigs.map(walletConfig => {
      return /*#__PURE__*/jsx("li", {
        "data-full-width": !!walletConfig.selectUI,
        children: walletConfig.selectUI ? /*#__PURE__*/jsx(walletConfig.selectUI, {
          modalSize: modalConfig.modalSize,
          theme: typeof modalConfig.theme === "string" ? modalConfig.theme : modalConfig.theme.type,
          supportedWallets: props.walletConfigs,
          onSelect: data => {
            props.selectWallet(walletConfig);
            setModalConfig(config => ({
              ...config,
              data
            }));
          },
          walletConfig: walletConfig,
          connect: options => props.selectUIProps.connect(walletConfig, options),
          connectionStatus: props.selectUIProps.connectionStatus,
          createWalletInstance: () => props.selectUIProps.createWalletInstance(walletConfig),
          setConnectedWallet: props.selectUIProps.setConnectedWallet,
          setConnectionStatus: props.selectUIProps.setConnectionStatus,
          connectedWallet: props.selectUIProps.connectedWallet,
          connectedWalletAddress: props.selectUIProps.connectedWalletAddress
        }) : /*#__PURE__*/jsx(WalletEntryButton, {
          walletConfig: walletConfig,
          selectWallet: () => {
            props.selectWallet(walletConfig);
          }
        })
      }, walletConfig.id);
    })
  });
};
function WalletEntryButton(props) {
  const {
    walletConfig,
    selectWallet
  } = props;
  const isRecommended = walletConfig.recommended;
  const locale = useTWLocale().connectWallet;
  const {
    screen
  } = useScreenContext();
  return /*#__PURE__*/jsxs(WalletButton, {
    type: "button",
    onClick: () => {
      selectWallet();
    },
    "data-active": screen === props.walletConfig,
    children: [/*#__PURE__*/jsx(Img, {
      src: walletConfig.meta.iconURL,
      width: iconSize.xl,
      height: iconSize.xl,
      loading: "eager"
    }), /*#__PURE__*/jsxs(Container, {
      flex: "column",
      gap: "xxs",
      expand: true,
      children: [/*#__PURE__*/jsx(Text, {
        color: "primaryText",
        weight: 600,
        children: walletConfig.meta.name
      }), isRecommended && /*#__PURE__*/jsx(Text, {
        size: "sm",
        children: locale.recommended
      }), !isRecommended && walletConfig.isInstalled && walletConfig.isInstalled() && /*#__PURE__*/jsx(Text, {
        size: "sm",
        children: locale.installed
      })]
    })]
  });
}
const WalletList = /* @__PURE__ */StyledUl({
  all: "unset",
  listStyleType: "none",
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  boxSizing: "border-box",
  overflowY: "auto",
  flex: 1,
  ...noScrollBar,
  // to show the box-shadow of inputs that overflows
  padding: "2px",
  margin: "-2px",
  marginBottom: 0,
  paddingBottom: spacing.lg
});
const WalletButton = /* @__PURE__ */StyledButton(() => {
  const theme = useCustomTheme();
  return {
    all: "unset",
    display: "flex",
    alignItems: "center",
    gap: spacing.sm,
    cursor: "pointer",
    boxSizing: "border-box",
    width: "100%",
    color: theme.colors.secondaryText,
    position: "relative",
    borderRadius: radius.md,
    padding: `${spacing.xs} ${spacing.xs}`,
    "&:hover": {
      backgroundColor: theme.colors.walletSelectorButtonHoverBg,
      transform: "scale(1.01)"
    },
    '&[data-active="true"]': {
      backgroundColor: theme.colors.walletSelectorButtonHoverBg
    },
    transition: "background-color 200ms ease, transform 200ms ease"
  };
});
function sortWalletConfigs(walletConfigs) {
  return walletConfigs
  // show the installed wallets first
  .sort((a, b) => {
    const aInstalled = a.isInstalled ? a.isInstalled() : false;
    const bInstalled = b.isInstalled ? b.isInstalled() : false;
    if (aInstalled && !bInstalled) {
      return -1;
    }
    if (!aInstalled && bInstalled) {
      return 1;
    }
    return 0;
  })
  // show the recommended wallets even before that
  .sort((a, b) => {
    if (a.recommended && !b.recommended) {
      return -1;
    }
    if (!a.recommended && b.recommended) {
      return 1;
    }
    return 0;
  })
  // show the wallets with selectUI first before others
  .sort((a, b) => {
    if (a.selectUI && !b.selectUI) {
      return -1;
    }
    if (!a.selectUI && b.selectUI) {
      return 1;
    }
    return 0;
  });
}

const FormFieldWithIconButton = props => {
  const errorEl = /*#__PURE__*/jsxs("div", {
    style: {
      opacity: props.error ? 1 : 0,
      transition: "opacity 0.2s ease"
    },
    children: [/*#__PURE__*/jsx(Spacer, {
      y: "sm"
    }), /*#__PURE__*/jsxs(Text, {
      color: "danger",
      size: "sm",
      children: [props.error, " \xA0"]
    })]
  });
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(Label, {
      htmlFor: props.id,
      children: props.label
    }), /*#__PURE__*/jsx(Spacer, {
      y: "sm"
    }), /*#__PURE__*/jsxs(InputContainer, {
      "data-error": !!props.error,
      children: [/*#__PURE__*/jsx(Input, {
        variant: "transparent",
        required: props.required,
        name: props.name,
        autoComplete: props.autocomplete,
        id: props.id,
        onChange: e => props.onChange(e.target.value),
        value: props.value,
        type: props.noSave ? "text" : props.type,
        style: props.type === "password" && props.noSave ? {
          WebkitTextSecurity: "disc"
        } : undefined,
        "data-test": props.dataTest,
        placeholder: props.placeholder
      }), /*#__PURE__*/jsx(InputButton, {
        type: "button",
        onClick: props.right.onClick,
        children: props.right.icon
      })]
    }), props.error && !props.noErrorShift && errorEl, props.noErrorShift && errorEl]
  });
};
const FormField = props => {
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(Label, {
      htmlFor: props.id,
      children: props.label
    }), /*#__PURE__*/jsx(Spacer, {
      y: "sm"
    }), /*#__PURE__*/jsx(Input, {
      variant: "outline",
      required: props.required,
      name: props.name,
      autoComplete: props.autocomplete,
      id: props.id,
      onChange: e => props.onChange(e.target.value),
      value: props.value,
      type: props.type,
      "data-error": !!props.errorMessage,
      placeholder: props.placeholder,
      disabled: props.disabled
    }), props.errorMessage && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Spacer, {
        y: "xs"
      }), /*#__PURE__*/jsx(Text, {
        color: "danger",
        size: "sm",
        children: props.errorMessage
      })]
    })]
  });
};

// maps safe chain id to safe-chain slug
const safeChainIdToSlug = {
  1: "eth",
  137: "matic",
  43114: "avax",
  56: "bnb",
  10: "oeth",
  8453: "base",
  11155111: "sep",
  100: "gno",
  1313161554: "aurora",
  42161: "arb1",
  42220: "celo",
  1101: "zkevm",
  324: "zksync"
};

// maps safe chain slug to chain id
const safeSlugToChainId = /* @__PURE__ */(() => {
  const result = {};
  for (const [chainId, prefix] of Object.entries(safeChainIdToSlug)) {
    result[prefix] = Number(chainId);
  }
  return result;
})();

export { ButtonLink as B, ConnectingScreen as C, ExtensionOrWCConnectionUI as E, FormFieldWithIconButton as F, GetStartedScreen as G, HeadlessConnectUI as H, PoweredByThirdweb as P, QRCode as Q, RainbowWallet as R, ScanScreen as S, TOS as T, WalletEntryButton as W, walletConnect as a, WalletLogoSpinner as b, coinbaseWallet as c, defaultWallets as d, WalletSelector as e, detectOS as f, WalletSelection as g, handelWCSessionRequest as h, isMobile as i, FormField as j, safeSlugToChainId as k, coinbaseWallet$1 as l, metamaskWallet as m, metamaskWallet$1 as n, openWindow as o, phantomWallet as p, walletConnect$1 as q, rainbowWallet as r, safeChainIdToSlug as s, trustWallet as t, TrustWallet as u, wait as w, zerionWallet as z };
